import { map } from 'lodash';

export const ruRU = {
    confirm: 'Подтвердить',
    common: {
        replace: 'Заменить',
        remove: 'Удалить',
        optional: 'Необязательно',
    },
    login: {
        identifier: 'Идентификатор',
        password: 'Пароль',
        login: 'Войти',
        verificationCodeFromSMS: 'Код подтверждения, полученный по SMS',
        messageWasSentToSMS: (key, { last4digits }) =>
            `На номер телефона, заканчивающийся на ${last4digits}, был отправлен SMS-код`,
        messageWasSentToEMAIL: (key, {maskedEmail}) => `На адрес ${maskedEmail} был отправлен код подтверждения`,
        checkSpamMessage: 'Если вы не можете найти код подтверждения, проверьте',
        spamFolder: 'папку спама',
        validate: 'Проверить',
        resendCode: 'Отправить код повторно',
        sendCode: 'Отправить код подтверждения',
        helloX: (key, { name }) => `Здравствуйте, ${name}`,
        otpDeliveryMethod: 'Как вы хотите получить код подтверждения?',
        sendBySMS: 'SMS',
        sendByEmail: 'Email',
        sendByWhatsApp: 'WhatsApp',
        messageWasSentToWhatsApp: (key, { last4digits }) => `На номер телефона, заканчивающийся на ${last4digits}, было отправлено сообщение WhatsApp`,
        chooseVerificationMethod: 'Выберите способ получения кода подтверждения:',
        noEmailContactManager: 'ваш email отсутствует в системе - обратитесь к менеджеру за помощью',
        noPhoneContactManager: 'ваш телефон отсутствует в системе - обратитесь к менеджеру за помощью',
    },
    otpLogin: {
        sendToEmail: 'Email',
        sendToPhone: 'SMS',
        sendToWhatsApp: 'WhatsApp',
        emailAddress: 'Адрес электронной почты',
        phoneNumber: 'Номер телефона',
        phonePlaceholder: 'Введите номер телефона',
        invalidPhoneNumber: 'Неверный номер телефона',
        sendVerificationCode: 'Отправить код подтверждения',
        title: 'Вход с кодом подтверждения',
        selectCompany: 'Выберите компанию',
        selectCompanySubtitle: 'Вы зарегистрированы в нескольких компаниях. Пожалуйста, выберите компанию, в которую хотите войти:',
        backToContactInfo: 'Вернуться к контактной информации',
    },
    changePassword: {
        currentPassword: 'Текущий пароль',
        password: 'Новый пароль',
        repeatPassword: 'Повторите новый пароль',
        changePassword: 'Сменить пароль',
        weakPassword: 'Пароль слишком слабый, он должен содержать хотя бы одну заглавную букву, одну цифру и быть длиной не менее 8 символов',
        newPasswordsDoesNotMatch: 'Пароли не совпадают',
        pleaseFillAllFields: 'Пожалуйста, заполните все обязательные поля',
    },
    logout: 'Выйти',
    menuItems: {
        logout: 'Выйти',
        changePassword: 'Сменить пароль',
        adminPanel: 'Админ-панель',
        home: 'Главная страница',
        myOrgs: 'Мои организационные единицы',
        learningCenter: 'Учебный центр',
        users: 'Пользователи',
        reports: 'Отчеты',
        settings: 'Настройки',
        learningManagement: 'Управление обучением',
        filesManagement: 'Управление файлами',
        knowledgeCenter: 'Центр знаний',
        operation: 'Операционная',
        superAdmin: {
            courses: 'Управление курсами',
            customers: 'Управление клиентами',
            organizations: 'Управление организационными единицами',
            users: 'Управление пользователями',
            dashboards: 'Отчеты',
            partners: 'Управление партнерами',
            assets: 'Управление активами',
            courseTemplates: 'Шаблоны курсов'
        },
    },
    languages: {
        label: 'Выберите язык',
        languageKeys: {
            heIL: 'עברית',
            enUS: 'English',
            arIL: 'العربية',
            ruRU: 'Русский',
            ptPT: 'Português'
        }
    },
    n8nChat: {
        title: 'Buzz AI',
        subtitle: 'Ваш AI-агент WeezBee',
        greeting: 'Привет, я Buzz AI - ваш AI-агент WeezBee. Как я могу помочь?',
        newConversation: 'Новый разговор',
        inputPlaceholder: 'Отправить сообщение здесь...',
        closeChat: 'Закрыть чат'
    },
    learningCenter: {
        title: 'Мой учебный центр',
        subTitle: 'Задачи и статус их выполнения',
        coursesToDo: 'Курсы, которые еще не завершены',
        coursesCompleted: 'Курсы, которые я завершил',
        noCoursesToDo: 'Нет незавершенных курсов',
        noCoursesCompleted: 'Нет завершенных курсов',
        signDocsToDo: 'Документы для подписания',
        noSignDocsToDo: 'Нет документов для подписания',
        noSignDocsCompleted: 'Нет подписанных мной документов',
        signDocsCompleted: 'Документы, которые я подписал',
        noOpenTasks: 'Нет открытых задач',

        // Archived SignDocs
        archivedSignDocs: 'Архивные задачи',
        noArchivedSignDocs: 'Нет архивных задач',
        versionsCount: (key, { count }) => `${count} версий`,
        versions: 'Версии',
        archivedVersions: 'Архивные версии',
        versionsNotFound: 'Версии не найдены',
        versionsNotFoundDescription: 'Архивные версии для этой задачи не найдены',

        // UPLOAD_DOCUMENT
        uploadsToDo: 'Документы, не утвержденные',
        uploadsCompleted: 'Утвержденные документы',
        noUploadsToDo: 'Нет документов для загрузки',
        noUploadsCompleted: 'Нет загруженных мной документов',

        tabs: {
            myCourses: 'Мои курсы',
            courses: 'Очное и онлайн-обучение',
            mySignDocs: 'Документы для подписания',
            myTasks: 'Открытые задачи',
            myCertifications: 'Сертификаты',
            myExams: 'Экзамены',
            myWeezbeeCourses: 'Курсы',
            learningPaths: 'Учебные пути',
            myVideos: 'Видео',
            myAudioFiles: 'Аудиофайлы',
            myLinks: 'Ссылки',
            surveys: 'Опросы',
            myPresentations: 'Презентации',
            uploads: 'Загрузки документов',
            myContent: 'Мой контент',
            archived: 'Архив',
        },
        searchMyContent: 'Поиск контента',
        searchMyContentPlaceholder: 'Поиск по названию...',
        filterByType: 'Фильтр по типу',
    },
    settingsPage: {
        title: 'Настройки',
        subTitle: 'Настройте систему',
        subTitleBold: 'под потребности вашей компании',
        buttons: {
            updateLogo: 'Обновить логотип',
            updateOrgName: 'Обновить названия организационных единиц',
            addOrg: "Добавить организационные единицы",
            updateNotes: 'Обновить заметки для сотрудников',
            adminInstructionCourse: "Курс обучения для администраторов",
        },
        editNotesModal: {
            title: 'Редактировать заметки для сотрудников',
        },
        addOrganizationModal: {
            organizationsList: 'Список организационных единиц',
            useCommaSeparatedValues:
                'Введите значения, разделенные запятыми, например: "Финансы, Бухгалтерия, Разработка ПО"',
            title: 'Добавить организационные единицы',
        },
        editOrganizationsNames: 'Редактировать названия организационных единиц',
        createNote: 'Создать новую заметку',
        newNoteTitle: 'Новая заметка',
        SMSQuota: {
            title: 'Лимит сообщений',
            quota: 'Приобретенные сообщения',
            sent: (key, { sent, quota }) =>
                `Обратите внимание, что на данный момент отправлено ${sent} сообщений и у вас осталось ${quota} сообщений для дальнейшего использования`,
            lastSMSWasSentOn: (key, { date }) =>
                `Последние сообщения были отправлены из системы ${date}`,
        },
        generalSettings: {
            title: 'Общее',
        },
        reminders: {
            title: 'Напоминания',
            course: 'Курс',
            signDoc: 'Документ для подписания',
            watchVideo: 'Посмотреть видео',
            listenAudio: 'Прослушать аудиофайл',
            canvaPresentation: 'Просмотр Canva',
            exam: 'Экзамен',
            learningPath: 'Учебный путь',
            link: 'Ссылка',
            survey: 'Опрос',
            weezbeeCourse: 'Онлайн-курс',
            frontalCourse: 'Очная лекция',
            onlineCourse: 'Онлайн-курс',
            uploadDocument: 'Загрузка документа',
        },
        admins: {
            title: 'Администраторы',
            subTitle: 'Управление и настройки',
        },
        setup: {
            title: 'Настройки установки'
        },
        deletedUsers: {
            title: 'Удалённые пользователи'
        },
        organizationalUnits: {
            title: 'Организационные подразделения',
        }
    },
    HomePage: {
        courseLegend: {
            completed: 'Завершено',
            inProgress: 'В процессе',
            notStarted: 'Не начато',
        },
    },
    home: {
        title: 'Доступные для вас курсы',
        faq: 'Часто задаваемые вопросы',
        welcome: 'Добро пожаловать',
        learningSubtitle: 'в вашу личную учебную среду для',
        userChartLabels: {
            finishedCourses: 'Завершенные курсы',
            inProgressCourses: 'Курсы в процессе',
            notStartedCourses: 'Курсы не начаты',
            label: 'Прогресс курсов',
        },
        superAdmin: 'Интерфейс администратора системы',
    },
    faq: {
        question1: 'Могу ли я в любое время вернуться к курсам?',
        answer1:
            'Да. Вы можете обучаться в своем темпе из любого места и в любое время, со смартфона или компьютера (мы рекомендуем использовать Google Chrome). Обратите внимание, что если вы начали курс, его необходимо завершить на том же устройстве.',
        question2: 'Что делать, когда я завершу курсы?',
        answer2:
            'Когда вы закончите курс, нажмите кнопку «Завершить» и подтвердите, что вы прошли курс. Убедитесь, что не осталось открытых задач.',
        question3: 'Нужна помощь?',
        answer3:
            'Не стесняйтесь связаться с нами по телефону 052-9663062 или по электронной почте info@nakarmedic.co.il',
    },
    gender: {
        male: 'Мужской',
        female: 'Женский',
    },
    OrganizationsPage: {
        title: 'Мои организационные единицы',
        subTitle: 'Управление и настройки',
        organizations: 'Организационные единицы, которые я администрирую',
        importUsersFile: 'Импорт файла пользователей',
        editLogo: 'Редактировать логотип',
        dropLogoHere: 'Перетащите логотип сюда',
        currentLogo: 'Текущий логотип',
        changeForAllMyOrganizations:
            'Изменить для всех организационных единиц, которыми я управляю',
        logoWillBeChangedForAllOrgs:
            '**Логотип будет изменен для всех организационных единиц под вашим управлением',
    },
    UsersPage: {
        title: 'Пользователи',
        subTitle: 'Управление и настройки',
        userRowCourseMenu: {
            buttons: {
                addToCourse: 'Зарегистрировать пользователя',
                removeFromCourse: 'Удалить регистрацию пользователя',
            },
        },
        userRowSignDocMenu: {
            buttons: {
                addToSignDoc: 'Зарегистрировать пользователя',
                removeFromSignDoc: 'Удалить регистрацию',
                markCompleted: 'Отметить как выполнено',
            },
            tooltips: {
                sessionNotToday: 'Посещаемость можно отметить только в день сеанса'
            }
        },
    },
    organizationUserTable: {
        headers: {
            name: 'Имя',
            permissions: 'Разрешения',
            identifier: 'Идентификатор',
        },
    },
    userType: {
        ADMIN: 'Администратор',
        USER: 'Пользователь',
    },
    note: {
        title: 'Заголовок',
        content: 'Содержание',
        delete: 'Удалить заметку',
        assignToAllOrganizations: 'Назначить всем организационным единицам',
        removeFromAllOrganizations: 'Удалить из всех организационных единиц',
        deleteNoteConfirmation: {
            title: 'Удалить заметку',
            message: 'Вы уверены, что хотите удалить заметку?',
            noteName: 'Название заметки',
            deleteNote: 'Удалить заметку',
        },
    },
    organization: {
        organizationName: 'Название организационной единицы',
    },
    courseCard: {
        youAreDone: 'Вы завершили курс',
        finishBy: (key, { finishByDate }) => `Завершить до ${finishByDate}`,
        youAreDoneWatchAgain: 'Посмотреть еще раз',
        goToCourse: 'Перейти к курсу',
    },
    courseProgress: {
        notStarted: 'Не начато',
        inProgress: 'В процессе',
        finished: 'Завершено!',
    },
    ReportsPage: {
        title: 'Отчеты',
        subTitle: 'Просмотр статуса завершения сотрудниками',
        courseLegend: {
            completed: 'Завершено',
            inProgress: 'В процессе',
            notStarted: 'Не начато',
        },
        coursesStats: {
            title: 'Статус завершения каждого курса',
        },
        signDocStats: {
            title: {
                course: 'Статус завершения каждого курса',
                signDocs: 'Статус подписания каждого документа',
            },
            exportToExcel: 'Экспорт в Excel',
            exporting: 'Экспорт...',
            exportCurrentFilters: 'Экспорт текущих фильтров',
            graphs: {
                usersPerformanceNumbers: (key, { taskCount = 0 }) =>
                    `Количество пользователей по статусу выполнения ${
                        taskCount ? `(${taskCount} задач)` : ''
                    }`,
                usersPerformancePercent: (key, { taskCount = 0 }) =>
                    `Процент пользователей по статусу выполнения ${
                        taskCount ? `(${taskCount} задач)` : ''
                    }`,
                performanceNumberByOrg: (key, { orgsCount = 0 }) =>
                    `Количество завершений в организационной единице ${
                        orgsCount ? `(${orgsCount} организационных единиц)` : ''
                    }`,
                performancePercentByOrg: (key, { orgsCount = 0 }) =>
                    `Процент завершения в организационной единице ${
                        orgsCount ? `(${orgsCount} организационных единиц)` : ''
                    }`,
                signDocsCount: ' Документов для подписания',
                activeCourseCount: 'Активные учебные элементы',
                usersCount: 'Пользователи',
                usersWithActiveTasks: 'Пользователи с активной задачей',
                allSignDocsOfACompanyCount: 'Учебные и тренировочные элементы',
                info: {
                    activeCourseCount:
                        'Общее количество учебных элементов с будущей датой окончания (курсы, документы для подписания и задачи просмотра)',
                    usersCount: 'Общее количество пользователей',
                    usersWithActiveTasks:
                        'Общее количество пользователей, у которых есть хотя бы одна активная задача',
                    allSignDocsOfACompanyCount:
                        'Общее количество учебных элементов (курсы, документы для подписания и задачи просмотра)',
                    performanceNumberByOrg:
                        'Общее количество выполненных задач из всех накопленных задач\n (Накопленные задачи = количество учебных и тренировочных элементов, умноженное на количество пользователей, назначенных на каждый элемент)',
                    performancePercentByOrg:
                        'Общее количество завершенных задач в каждой организационной единице',
                },
            },
        },
        tabs: {
            dashboard: 'Главная панель',
            allReports: 'Отчеты по обучению',
            courses: 'Курсы',
            signDocs: 'Документы для подписания',
            generatedReports: 'Сформированные отчеты',
            KnowledgeCenter: 'Центр знаний',
            operation: 'Операционная',
        },
    },
    learningPathReport: {
        status: {
            completed: 'Завершено',
            inProgress: 'В процессе',
            notStarted: 'Не начато'
        }
    },
    courseReports: {
        title: 'Отчеты по курсам',
        defaultTitle: 'Курс',
        subtitle: (key, { completed, assigned, rate }) => `${completed} из ${assigned} завершили (${rate}%)`,
        organization: 'Организационная единица',
        allOrganizations: 'Все организационные единицы',
        completed: 'Завершено',
        notFound: 'Курс не найден',
        card: {
            sessionDate: 'Дата сессии',
            noSessionDate: 'Дата не установлена',
            viewFullReport: 'Посмотреть полный отчет',
            completionRate: 'Процент завершения'
        },
        downloadReport: 'Скачать отчет по задачам',
        noCourses: {
            title: 'Нет доступных курсов',
            message: 'Курсы не найдены для выбранных организационных единиц'
        }
    },
    signDocReports: {
        searchLabel: 'Поиск',
        searchPlaceholder: 'Поиск по названию...',
        filterByType: 'Фильтр по типу контента',
        noSignDocs: {
            title: 'Нет доступного контента',
            message: 'Контент не найден для выбранных организационных единиц'
        }
    },
    courseProgressMgmnt: {
        notStarted: 'Не начато',
        inProgress: 'В процессе',
        finished: 'Завершено',
        attended: 'Присутствовал',
        noShow: 'Не явился',
        completedOn: 'Дата подписания: ',
        completedOnCourse: 'Дата завершения: ',
        by: 'от ',
        manual: 'Вручную',
        finishBy: 'Завершить до: ',
    },
    LearningManagementPage: {
        title: 'Управление обучением',
        subTitle: 'Добавлять, редактировать и удалять',
        addCourse: 'Добавить курс',
        editCourse: 'Редактировать курс',
        deleteCourse: 'Удалить курс',
        courseName: 'Название курса',
        courseDescription: 'Описание курса',
        courseImage: 'Изображение курса',
        createKnowledgeSource: 'Создать источник знаний',
        createQuestionnaire: 'Создать анкету',
        createExam: 'Создай экзамен',
        courseCard: {
            editCourse: 'Редактировать курс',
        },
        signDocCard: {
            editSignDoc: {
                READ_AND_SIGN_DOC_PDF: 'Редактировать документ',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'Редактировать задачу просмотра',
                WATCH_AND_SIGN_VIMEO_LINK: 'Редактировать задачу просмотра',
                WATCH_AND_SIGN_VIDEO_FILE: 'Редактировать задачу просмотра',
                REGULAR_COURSE: 'Редактировать курс',
                CANVA_PRESENTATION: 'Редактировать презентацию',
                EXAM: 'Редактирование экзамена',
                FRONTAL_COURSE: 'Редактировать фронтальную лекцию',
                ONLINE_COURSE: 'Редактировать онлайн-курс'
            },
            deleteModal: {
                title: 'Удалить документ',
                text: 'Вы уверены, что хотите удалить этот документ? Это действие необратимо',
                confirm: 'Удалить документ',
                cancel: 'Отмена',
                signDocName: 'Название документа',
                deleteAllVersionsCheckbox: 'Удалить все версии этого документа',
                warningAllVersions: '⚠️ Предупреждение: Удаление этого документа приведет к удалению всех версий документа'
            },
            versionManagement: 'Управление версиями',
        },
        users: {
            buttons: {
                downloadCsv: 'Экспорт в CSV',
                downloadCsvForOrganizations:
                    'Скачать отчет о задачах для пользователей из выбранных организационных единиц',
                downloadUserDetailsForOrganizations:
                    'Экспорт данных пользователей для выбранных организационных единиц',
                downloadSelectedUsers: 'Скачать отчет о задачах для выбранных пользователей',
                downloadCsvForOrganization:
                    'Экспорт пользователей для выбранной организационной единицы',
                downloadCsvForAllOrganizations:
                    'Экспорт пользователей для всех организационных единиц, которыми я управляю',
            },
            messages: {
                exportStarted: 'Экспорт начат. Переход к отчетам...',
                exportFailed: 'Экспорт не удался. Пожалуйста, попробуйте еще раз.',
                noUsersSelected: 'Пожалуйста, выберите пользователей для экспорта',
            }
        },
        courseManagement: 'Управление курсами',
        signDocManagement: 'Управление документами',
        noSignDocs: 'Нет документов для отображения',
        noSearchResults: 'По вашему запросу ничего не найдено',
        noSearchResultsHint: 'Попробуйте изменить условия поиска или очистите поиск, чтобы увидеть все элементы',
        tabs: {
            signDocs: 'Документы для подписания',
            courses: 'Курсы',
            frontalCourses: 'Очное обучение',
            onlineCourses: 'Онлайн-обучение',
            users: 'Пользователи',
            tasks: 'Задачи',
            knowledgeCenter: 'Центр знаний',
            operation: 'Операционная',
            questionnaire: 'Опросники',
            archive: 'Архив',
        },
        searchTasks: 'Поиск задач',
        searchTasksPlaceholder: 'Поиск по названию...',
        filterByType: 'Фильтр по типу',
        filterByTypePlaceholder: 'Выберите типы...',
        allTypes: 'Все типы',
        typeNames: {
            READ_AND_SIGN_DOC_PDF: 'Документы для подписи',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Видео',
            WATCH_AND_SIGN_VIMEO_LINK: 'Видео',
            WATCH_AND_SIGN_VIDEO_FILE: 'Видео',
            VIDEOS: 'Видео',
            REGULAR_COURSE: 'Курсы',
            CANVA_PRESENTATION: 'Презентации',
            EXAM: 'Экзамены',
            LEARNING_PATH: 'Учебные пути',
            SURVEY: 'Опросники',
            ARTICLE: 'Статьи',
            AUDIO_FILE: 'Аудиофайлы',
            LINK: 'Ссылки',
            PODCAST: 'Подкасты',
            FRONTAL_COURSE: 'Фронтальные курсы',
            ONLINE_COURSE: 'Онлайн-курсы',
            PRESENTATION: 'Презентации',
            WEEZBEE_COURSE: 'Курсы',
            UPLOAD_DOCUMENT: 'Загрузить документы',
        },
    },
    editCourseModal: {
        title: 'Редактировать курс',
        courseName: 'Название курса',
        courseDescription: 'Описание курса',
        courseImage: 'Изображение курса',
        save: 'Сохранить изменения',
        edit: {
            courseName: 'Название курса',
            courseDescription: 'Описание курса',
            dateEditNotification:
                'Вы можете установить единый срок завершения для всех пользователей, зарегистрированных на курс во всех управляемых вами организационных единицах. Любые изменения здесь переопределят индивидуальные настройки пользователей.',
        },
        dateModal: {
            title: 'Установить дату окончания',
            timeAndTimezone: 'До 00:00 в часовом поясе: ',
        },
    },
    editUserCourseModal: {
        title: (key, { userName, courseName }) =>
            `Установить дату окончания курса "${courseName}" для пользователя "${userName}"`,
        dateEditNotification:
            'Вы можете установить дату окончания для пользователя. Это изменение будет действовать, пока вы не измените дату окончания для всей организационной единицы.',
    },
    AppSideMenu: {
        welcome: 'Добро пожаловать',
    },
    superAdmin: {
        partnersTable: {
            columns: {
                clientSecretExpiresAt: 'Срок действия Client Secret',
            }
        },
        cronJobs: {
            sectionTitle: 'Запланированные задачи',
            runRecurringRenewal: 'Запустить периодическое обновление',
            running: 'Выполняется...',
            renewalSuccess: 'Периодическое обновление завершено успешно',
            renewalError: 'Периодическое обновление не удалось. Проверьте логи сервера.',
        },
        assets: {
            title: 'Управление активами',
            columns: {
                fileName: 'Имя файла',
                type: 'Тип',
                company: 'Компания',
                createdBy: 'Создано',
                tags: 'Теги',
                lastModified: 'Последнее изменение',
                download: 'Скачать',
                thumbnail: 'Предпросмотр'
            },
            filters: {
                companyName: 'Название компании',
                type: 'Тип файла',
                all: 'Все',
                image: 'Изображение',
                video: 'Видео',
                clear: 'Очистить фильтры',
                generalBank: 'Общий банк'
            },
            fileTypes: {
                image: 'Изображение',
                video: 'Видео',
                file: 'Файл'
            },
            download: 'Скачать файл',
            downloadError: 'Ошибка при скачивании файла',
            loading: 'Загрузка...',
            thumbnailError: 'Ошибка загрузки предпросмотра',
            thumbnail: 'Предпросмотр файла',
            upload: {
                title: 'Загрузить в общий банк',
                uploadButton: 'Загрузить актив',
                cancel: 'Отмена',
                upload: 'Загрузить',
                dragDrop: 'Перетащите файл сюда или нажмите, чтобы выбрать файл',
                supportedTypes: 'Поддерживаемые типы файлов: Изображения (.jpg, .png, .gif) и Видео (.mp4, .mov, .avi)',
                presentationName: 'Отображаемое имя',
                presentationNamePlaceholder: 'Введите имя для файла',
                description: 'Описание',
                descriptionPlaceholder: 'Введите описание для файла',
                noFileSelected: 'Пожалуйста, выберите файл для загрузки',
                error: 'Произошла ошибка при загрузке файла',
                uploading: 'Загрузка'
            },
            tags: {
                editTags: 'Редактировать теги',
                enterTagsPlaceholder: 'Введите теги, разделенные запятыми',
                tagsHelperText: 'Теги помогают организовать и легче находить активы',
                andMoreTags: (key, { count }) => `и еще ${count}`,
                noTags: 'Нет тегов',
                save: 'Сохранить',
                cancel: 'Отмена'
            }
        },
        courseTemplates: {
            title: 'Шаблоны курсов',
            placeholder: 'Функциональность шаблонов курсов будет доступна в ближайшее время. Эта страница позволит вам создавать, редактировать и управлять шаблонами курсов, которые можно использовать на всей платформе.',
            columns: {
                templateName: 'Название шаблона',
                templateSubject: 'Тема',
                description: 'Описание',
                createdBy: 'Создано',
                isPubliclyAccessible: 'Общедоступный',
                isReady: 'Готов',
                actions: 'Действия'
            },
            buttons: {
                createTemplate: 'Создать новый шаблон',
                editTemplate: 'Редактировать шаблон',
                deleteTemplate: 'Удалить шаблон',
                viewTemplate: 'Просмотреть шаблон'
            },
            searchPlaceholder: 'Поиск шаблонов...',
            noTemplates: 'Шаблоны не найдены. Создайте свой первый шаблон, нажав на кнопку выше.',
            fetchError: 'Не удалось загрузить шаблоны. Пожалуйста, попробуйте позже.',
            searchError: 'Не удалось выполнить поиск шаблонов. Пожалуйста, попробуйте позже.',
            deleteError: 'Не удалось удалить шаблон. Пожалуйста, попробуйте позже.',
            confirmDelete: 'Вы уверены, что хотите удалить этот шаблон?'
        },
        editFFModal: {
            modalTitle: 'Редактировать функции компании',
            editFeatures: 'Редактировать функции',
            paths: {
                basic: 'Базовый',
                creator: 'Создатель',
                enterprise: 'Корпоративный'
            },
            deals: {
                messaging: 'Сообщения и коммуникация',
                contentTypes: 'Типы контента',
                courses: 'Курсы и обучение',
                automation: 'Автоматизация',
                advanced: 'Расширенные функции',
                organization: 'Управление организацией',
                system: 'Системные настройки'
            },
            dealStatus: {
                allEnabled: 'Все включено',
                partiallyEnabled: 'Частично включено',
                disabled: 'Отключено'
            },
            featureFlags: {
                automationFF: 'Автоматизация',
                smsFF: 'SMS',
                whatsappFF: 'WhatsApp',
                emailFF: 'Email',
                signDocsFF: 'Задачи',
                sendWelcomeMessageFF: 'Отправлять приветственные сообщения новым пользователям',
                signDocsReadAndSignDocPdfFF: 'Подписывать PDF',
                signDocsWatchAndSignYoutubeLinkFF: 'Подтверждать просмотр Youtube',
                signDocsWatchAndSignVimeoLinkFF: 'Подтверждать просмотр Vimeo',
                signDocsWatchAndSignVideoFileFF: 'Подтверждать просмотр видеофайла',
                signDocCanvaPresentationFF: 'Презентация Canva',
                regularCourseFF: 'Курсы',
                notifyNewTaskToUserFF: 'Уведомлять пользователя о новой задаче',
                knowledgeCenterFF: 'Центр знаний',
                orgAdminMgmtFF: 'Управление правами администратора',
                languagesFF: 'Языки',
                examsFF: 'Экзамены',
                weezbeeCourseFF: 'Курс WeezBee',
                AIFF: 'ИИ',
                learningPathFF: 'Траектория обучения',
                signDocsAudioFileFF: 'Аудиофайл',
                linkFF: 'Ссылки',
                surveyFF: 'Опросы',
                recurringAutomationFF: 'Повторяющаяся автоматизация',
                uploadDocumentFF: 'Загрузка документов',
                certificationFF: 'Сертификации',
                subAdminCanCreateOrgFF: 'Суб-админ может создавать организации',
                phoneE164MigrationFF: 'Миграция на формат телефона E.164',
                bulkUserRefactorFF: 'Массовое управление пользователями V2',
                operationModeFF: 'Режим операций (переименовать Центр знаний)',
                mustDoComplianceFF: 'Обязательное соответствие'
            },
        },
        allUsersTable: {
            columns: {
                firstName: 'Имя',
                lastName: 'Фамилия',
                email: 'Email',
                phone: 'Телефон',
                roles: 'Роли',
                identifier: 'Идентификатор',
                organization: 'Организационная единица',
                id: 'ID',
                companyName: 'Компания',
                yes: 'Да',
                no: 'Нет',
                isSuperAdmin: 'Супер-админ',
                isCompanyAdmin: 'Админ компании',
                isDeleted: 'Удален',
                edit: 'Редактировать',
                permanentlyDelete: 'Удалить безвозвратно',
                loginUrl: 'Ссылка для входа',
                userCreatedSmsDate: 'Дата приветственного SMS',
            },
            buttons: {
                downloadCsvForOrganization:
                    'Скачать Excel-файл для организационной единицы',
                downloadCsvForAllOrganizations:
                    'Скачать Excel-файлы для всех организационных единиц, которыми я управляю',
                downloadCsvForOrganizationSuccess:
                    'Ваши файлы вскоре будут доступны для загрузки в разделе «Меню -> Управление файлами»',
                deleteUsers: 'Удалить пользователей',
                edit: 'Редактировать',
            },
        },
        allOrgsTable: {
            columns: {
                orgName: 'Название организационной единицы',
                taxIdentifier: 'Идентификатор',
                companyId: 'ID компании',
                orgAddress: 'Адрес',
                orgContactInfo: 'Контактная информация',
                id: 'ID',
                companyName: 'Название компании',
                delete: 'Удалить',
            },
            deleteOrg: 'Удалить организационную единицу',
            deleteOrgTitle: 'Удалить организационную единицу: ',
            deleteOrgText: 'Вы уверены, что хотите удалить эту организационную единицу',
            deleteOrgConfirm: 'Удалить организационную единицу',
        },
        createNewCourse: {
            title: 'Создать новый курс',
            docName: 'Название курса',
            courseDescription: 'Описание курса',
            create: 'Создать курс',
            companyName: 'Название компании',
            dropZipHere:
                'Перетащите zip-файл курса сюда или нажмите, чтобы выбрать файл',
            modalTitle: 'Создать новый курс',
            organizationsTable: {
                orgName: 'Название организационной единицы',
                addOrganization: 'Добавить курс в организационную единицу',
                removeOrganization: 'Удалить курс из организационной единицы',
                onlyOneCompanyPerCourse:
                    'Курс можно добавить только к одной компании, поэтому сейчас нельзя изменить выбор компании',
            },
        },
        createNewCustomer: {
            modalTitle: 'Создать нового клиента',
            companyName: 'Название компании',
            userPrefix:
                'Префикс пользователя (уникален для каждой компании – только на английском)',
            identifier: 'Идентификатор',
            contactEmail: 'Контактный email',
            contactName: 'Контактное лицо',
            contactPhone: 'Телефон контактного лица',
            userCreationTitle: 'Создать первого пользователя компании',
            detailsTitle: 'Заполните данные компании',
            userPassword: 'Пароль пользователя (только английский)',
            userIdentifier: 'Идентификатор пользователя (только английский)',
            createCompany: 'Создать компанию',
            userNameNoteNoPrefix:
                '*Необходимо указать префикс пользователя прежде, чем вводить имя пользователя',
            userNameNote: (key, { companyUsersPrefix, userIdentifier }) =>
                `*Фактическое имя пользователя, которое будет создано: ${companyUsersPrefix}-${
                    userIdentifier || '"User Identifier"'
                }`,
            userPrefixError: 'Префикс пользователя должен быть только на английском',
            userFirstName: 'Имя',
            userLastName: 'Фамилия',
            contactFirstName: 'Имя контактного лица',
            contactLastName: 'Фамилия контактного лица',
            countryCode: 'Страна',
        },
        editCourse: {
            courseName: 'Название курса',
            docName: 'Название курса',
            courseDescription: 'Описание курса',
            companyName: 'Название компании',
            description: 'Описание курса',
            dropZipHere:
                'Перетащите zip-файл курса сюда или нажмите, чтобы выбрать файл',
            dropZipNote:
                '**Обратите внимание, что вы находитесь в режиме редактирования. Если zip-файл уже загружен для этого курса, загрузка нового файла перезапишет существующий**',
            saveChanges: 'Сохранить изменения',
            modalTitle: 'Редактировать курс',
        },
        editCustomer: {
            modalTitle: 'Редактировать клиента',
            adminUserDetails: 'Данные главного пользователя',
            detailsTitle: 'Редактировать данные компании',
            organizationsTitle: 'Организационные единицы клиента',
            addOrganizations: 'Добавить организационные единицы клиенту',
            addOrganizationModal: {
                organizationsList: 'Список организационных единиц',
                useCommaSeparatedValues:
                    'Введите значения, разделенные запятыми, например: "Финансы, Бухгалтерия, Разработка ПО"',
                title: 'Добавить организационные единицы клиенту',
            },
            mfaForAllUsers: 'Требовать MFA для всех пользователей компании',
        },
        coursesTable: {
            columns: {
                courseName: 'Название задачи',
                description: 'Описание задачи',
                edit: 'Редактировать',
                type: 'Тип задачи',
                editCourse: 'Редактировать курс',
                companyName: 'Название компании',
                remove: 'Удалить',
                uploadStatus: 'Статус загрузки',
            },
            uploadStatus: {
                READY: 'Готово',
                UPLOADING: 'Загрузка...',
                FAILED: 'Ошибка',
            }
        },
        customersTable: {
            columns: {
                companyName: 'Название компании',
                taxIdentifier: 'Идентификатор',
                edit: 'Редактировать',
                editCompany: 'Редактировать компанию',
                smsQuota: 'Кредит сообщений',
                userQuota: 'Квота пользователей',
                activeUsers: 'Активные пользователи',
                featureFlags: 'Функции',
                storageQuotaMB: 'Хранилище (MB)',
                editQuota: 'Редактировать квоты',
                welcomeMessage: 'Отправить приветственное сообщение',
                welcomeMessageSent: 'Сообщение отправлено',
                delete: 'Удалить',
            },
            deleteCompany: {
                button: 'Удалить',
                title: 'Безвозвратное удаление компании',
                warning: 'Это безвозвратно удалит компанию и ВСЕ её данные. Это действие нельзя отменить.',
                backupNote: 'Учебные записи компании (данные UserSignDoc) сохраняются в S3 перед удалением.',
                confirmLabel: 'Введите название или идентификатор компании для подтверждения:',
                confirmPlaceholder: 'Название или идентификатор компании',
                cancel: 'Отмена',
                confirm: 'Удалить компанию',
                deleting: 'Удаление...',
                success: 'Компания успешно удалена',
                error: 'Не удалось удалить компанию. Попробуйте ещё раз.'
            },
            welcomeMessage: {
                confirmTitle: 'Отправить приветственное сообщение для компании',
                confirmMessage: 'Вы уверены, что хотите отправить приветственные сообщения всем пользователям этой компании?',
                detailsTitle: 'Детали приветственного сообщения',
                sentDate: 'Дата отправки:',
                sentBy: 'Отправлено:',
                company: 'Компания:'
            },
            quota: {
                editQuota: 'Редактировать квоты',
                editQuotaTitle: 'Редактировать квоты для компании',
                editCredits: 'Редактировать кредиты',
                editUserQuota: 'Квота пользователей',
                MessagesCreditsToEdit: 'Кредиты сообщений',
                storageQuotaToEdit: 'Хранилище в MB',
            },
        },
    },
    dataGrid: {
        filters: {
            search: {
                input: 'Поиск',
            },
        },
        filterLabels: {
            course: 'Курс',
            organization: 'Организационная единица',
            company: 'Компания',
            signDoc: 'Задачи',
            fileType: 'Тип файла'
        },
        footer: {
            rowsSelected: (key, {count}) => count === 1 ? 'Выбрана 1 строка' : `Выбрано строк: ${count}`
        },
    },
    importUsersPage: {
        downloadExample: 'Скачать пример файла для создания пользователей',
        downloadUsersAsCSV: 'Скачать пользователей в формате CSV',
    },
    importUsersModal: {
        title: 'Импорт/редактирование пользователей и единиц',
        tabs: {
            importUsers: {
                title: 'Импорт пользователей и добавление единиц',
            },
            reorganizeUsers: {
                title: 'Импорт пользователей и изменение единиц',
            },
        },
        manyUsersMessage:
            'Похоже, что в файле много пользователей, импорт может занять несколько минут. После нажатия «Создать» просьба не закрывать окно до окончания загрузки, а затем подождать еще несколько минут, пока изменения отобразятся в системе.',
        users: {
            firstName: 'Имя',
            lastName: 'Фамилия',
            identifier: 'Идентификатор',
            phone: 'Телефон',
            email: 'Email',
            organizations: 'Организационные единицы',
            organizationsAliases: ['Организационная единица', 'Организации', 'Организация', 'Единицы', 'Единица'],
        },
        createUsers: 'Создать/редактировать пользователей',
        selectOrganization:
            'Выберите организационные единицы, для которых будут созданы пользователи',
        selectOrganizationsToAdd: 'Выберите организационные единицы для добавления',
        organization: 'Организационная единица',
        newUsersWillBeCreatedAndOrganizationsWillBeAddedToAllUsers:
            'Эти организационные единицы будут добавлены всем пользователям, найденным в прилагаемом файле. Пользователи, которых нет в системе, будут созданы, а существующие будут обновлены.',
        newUsersWillBeCreatedAndOrganizationsWillBeOverride:
            'Организационные единицы будут изменены для всех пользователей в прилагаемом файле (пользователи будут удалены из тех единиц, которые не выбраны). Не существующие пользователи будут созданы, а существующие будут обновлены.',
        errors: {
            missingMandatoryField: (key, { row }) =>
                `*Отсутствуют обязательные поля в строке ${row}:`,
            twoSourcesForOrgs:
                'Нельзя выбирать организационные единицы из двух источников. Удалите организационные единицы из импортируемого файла или из выбора выше',
            removeOrgsFromFile: 'Удалите организационные единицы из импортируемого файла',
            missingSourceForOrgs:
                'Не выбраны организационные единицы для пользователей. Выберите единицы вверху страницы или добавьте их в шаблон импорта.',
            missingSourceForOrgsSelectFromMultiSelect:
                'Не выбраны организационные единицы для пользователей. Выберите их в списке выше.',
            noFirstNameColumn: 'Файл должен содержать столбец с названием "First Name"',
            noLastNameColumn: 'Файл должен содержать столбец с названием "Last Name"',
            emptyExcelFile: 'Файл Excel пустой или не содержит листа',
            invalidExcelFile: 'Файл Excel поврежден или недействителен, проверьте файл и попробуйте снова',
            unsupportedFileType: 'Тип файла не поддерживается. Загрузите файл CSV или Excel (.xlsx, .xls)',
            missingColumn: (key, {columnName}) => `Файл должен содержать столбец с названием "${columnName}"`,
        },
    },
    uploadBox: {
        uploading: 'Идет загрузка файла...',
        uploaded: 'Файл успешно загружен',
        uploadFailed:
            'Файл недействителен. Проверьте размер и тип файла, чтобы убедиться, что не превышен допустимый лимит.',
        maxFileSize: (key, { maxFileSize }) =>
            `Максимально допустимый размер файла — ${maxFileSize}`,
        onlyFileTypes: (key, { fileTypes }) =>
            `Допустимые типы файлов для загрузки: ${map(fileTypes, (fileType) => `${fileType}`).join(', ')}`,
    },
    completedCoursePage: {
        title: 'Завершение курса',
        subTitle: 'Пожалуйста, подтвердите, что вы завершили курс',
        buttons: {
            confirmCourseCompletion: 'Подтверждаю, что завершил(а) курс',
        },
        finishedSuccessfully: 'Вы успешно завершили курс',
        oops: 'Упс...',
        youGotLost: 'Кажется, вы заблудились, используйте меню для навигации',
        courseCompletedSuccessfullyPopup: 'Вы успешно завершили курс',
    },
    errors: {
        clientError: 'Ошибка в предоставленных данных',
        serverError: 'Ошибка запроса к серверу',
        generalServerError:
            'Общая ошибка запроса к серверу. Попробуйте перезагрузить страницу. Если проблема повторяется, обратитесь в техническую поддержку.',
        notFound: 'Ресурс не найден',
        forbidden: 'У вас нет прав доступа к этому ресурсу',
        privateRouteUserNotLoggedIn:
            'Пользователь не авторизован, поэтому доступ к содержимому невозможен. Пожалуйста, войдите в систему и попробуйте снова.',
        session_expired: 'Срок действия вашей сессии истек. Пожалуйста, войдите снова, чтобы продолжить.',
        too_many_requests: 'Ошибка, вы попытались слишком много раз, попробуйте позже'
    },
    alertDialog: {
        ok: 'ОК',
        cancel: 'Отмена',
    },
    orphanedUsers: {
        filterLabel: 'Без организации',
        alertMessage: 'активных пользователей не привязаны ни к одной организации. Чтобы исправить: выберите «Без организации» в фильтре, затем нажмите «Редактировать» для каждого пользователя и назначьте организацию.',
    },
    createEditUserModal: {
        editPhone: 'Изменить телефон',
        organizationsLabel: 'Организационные единицы',
        selectAllOrganizations: 'Выбрать все организационные единицы',
        identifier: 'Идентификатор',
        createUser: 'Создать пользователя',
        saveFailed: 'Не удалось сохранить. Попробуйте ещё раз.',
        titleCreate: 'Создать/обновить пользователя',
        titleEdit: 'Редактировать пользователя',
        selectOrganization: 'Выберите организационную единицу',
        firstName: 'Имя',
        lastName: 'Фамилия',
        identifier: 'Идентификатор',
        phone: 'Телефон',
        email: 'Email',
        editUser: 'Редактировать пользователя',
        deleteUserTitle: 'Удалить пользователя',
        sendWelcomeMessageConfirm: 'Отправить сообщение',
        deleteUserText: 'Вы уверены, что хотите удалить пользователя',
        deleteOrgConfirm: 'Удалить пользователя',
        deleteUserButton: 'Удалить пользователя',
        userIsCompanyAdmin: 'Администратор компании',
        userIsOrgAdmin: 'Администратор организационной единицы',
        userIsOrgAdminTooltip: 'Чтобы удалить этого пользователя, сначала нужно убрать его из управленческих ролей во всех организационных единицах',
        mfaRequired: 'Требуется двухфакторная аутентификация',
        sendWelcomeMessage: 'Отправить приветственное сообщение при первой авторизации',
        save: 'Сохранить/обновить пользователя',
        userWillBeEditedIfPhoneExists:
            'Если этот номер телефона уже связан с пользователем в компании, этот пользователь и его организационные единицы будут обновлены',
    },
    phoneEditModal: {
        title: 'Редактировать номер телефона',
        phoneLabel: 'Номер телефона',
        phonePlaceholder: 'Введите номер телефона',
        cancel: 'Отмена',
        save: 'Сохранить',
        errors: {
            phone_already_exists: 'Этот номер телефона уже существует в системе',
            phone_belongs_to_inactive_user: 'Этот номер телефона принадлежит неактивному пользователю',
            invalid_phone_format: 'Неверный формат номера телефона',
            no_permission: 'Нет разрешения на обновление номера телефона',
            network_error: 'Ошибка сети, попробуйте еще раз',
            check_failed: 'Проверка доступности не удалась, попробуйте еще раз',
        },
    },
    recurringAtEditModal: {
        title: 'Редактировать дату следующей версии',
        dateLabel: 'Дата следующей версии',
        disclaimer: 'Изменение даты следующей версии будет применено ко всем пользователям, назначенным на эту задачу.',
        cancel: 'Отмена',
        save: 'Сохранить',
        errors: {
            saveFailed: 'Не удалось обновить дату, попробуйте снова',
        },
    },
    allUsersTable: {
        columns: {
            firstName: 'Имя',
            lastName: 'Фамилия',
            email: 'Email',
            phone: 'Телефон',
            roles: 'Роли',
            identifier: 'Идентификатор',
            organization: 'Организационная единица',
            id: 'ID',
            edit: 'Редактировать',
            delete: 'Удалить',
            sendWelcomeMessage: 'Отправить приветственное сообщение',
            progress: 'Прогресс',
            notRegistered: 'Не зарегистрирован на курс',
        },
        buttons: {
            deleteUsers: 'Удалить пользователей',
        },
        filters: {
            allUsers: 'Все пользователи',
            activeOnly: 'Только активные пользователи',
            deletedOnly: 'Только удаленные пользователи',
        }
    },
    removeCourseFromCompanyCol: {
        deleteCourseButton: 'Удалить курс',
        removeCourseTitle: 'Удалить курс',
        removeCourseText: 'Вы уверены, что хотите удалить курс',
        removeCourseConfirm: 'Удалить курс',
    },
    CourseReminderNotificationButton: {
        alerts: {
            reminderSent: 'Напоминания отправляются!',
            reminderNotSent: 'Произошла ошибка при отправке напоминания',
            sentMessages: 'Сообщения отправлены',
            notSentMessages: 'Сообщения не были отправлены',
            notSentMessagesInfo:
                '* Существует две возможные причины, по которым не все сообщения были отправлены: отсутствие контактной информации или неправильный номер телефона',
            sendToUsersWhoDidNotReceiveNotification:
                'Отправить напоминание пользователям, которые еще его не получили',
            sendToAllUsers:
                'Отправить напоминание всем пользователям курса, которые еще не завершили',
            error: 'Ошибка',
            company_has_no_sms_quota:
                'В компании недостаточно SMS-кредитов, обратитесь в службу поддержки для приобретения пакета сообщений',
            user_already_received_welcome_message: 'Пользователь уже получил приветственное сообщение',
            general_error: 'Произошла ошибка при отправке уведомления, попробуйте позже'
        },
    },
    FilesManagementPage: {
        title: 'Управление файлами',
        subTitle: 'Просмотр, добавление и редактирование',
        fileManagementTable: {
            columns: {
                fileName: 'Ссылка для загрузки',
                presentationName: 'Отображаемое имя',
                isReady: 'Готов для скачивания',
                companyName: 'Компания',
                organizationNames: 'Организационные единицы',
                date: 'Дата создания',
                createdByUser: 'Создан пользователем',
            },
            download: 'Скачать',
            inProgress: 'Создается',
            ready: 'Готов к загрузке',
            allOrganizations: 'Все организационные единицы',
        },
    },
    SMSNotificationButton: {
        title: 'Отправить напоминание',
        subTitle: 'Немедленно',
    },
    sendSMSModal: {
        title: 'Кому напомним?',
        sms: 'SMS',
        whatsapp: 'WhatsApp',
        email: 'Email',
        selectMessageDeliveryWay: 'Сообщения будут отправлены через:',
        sendToOptions: {
            all: 'Пользователи, не завершившие конкретную задачу',
            onlyNotNotified: 'Все, кто не завершил курс и не получал напоминание',
            allWithAnyOpenTasks: 'Пользователи с открытыми задачами',
            knowledgeCenter: 'Центр знаний',
            pleaseSelect: 'Пожалуйста, выберите группу, которой хотите отправить напоминание',
            label: 'Кому?',
        },
        taskOptions: {
            label: 'Какое задание?',
            pleaseSelect: 'Пожалуйста, выберите курс, по которому хотите отправить напоминание',
        },
        organizationOptions: {
            label: 'Какая организационная единица?',
            pleaseSelect: 'Пожалуйста, выберите организационную единицу, по которой хотите отправить напоминание',
        },
        smsStatusInformation: {
            statusTitle: 'Отлично!',
            statusUserToNotify: 'Итого мы отправим напоминание ',
            bySMS: 'через SMS',
            byWhatsApp: 'через WhatsApp',
            byEmail: 'через Email',
            statusCompanyQuota: 'Учтите, что после отправки у вас останется ',
            SMSForUse: 'сообщений для дальнейшего использования',
            employees: 'сотрудникам',
            theyWillReceiveItAsFollowing: 'которые получат сообщения следующим способом',
            existing: 'существующие',
            usersDontHaveEmails: 'пользователи без адресов электронной почты'
        },
        error: {
            noUsersToSendOnlyNotNotified:
                'Нет пользователей для отправки; все, кто не завершил курс, уже получили напоминание',
            notEnoughSMS:
                'У вас недостаточно SMS-кредитов, свяжитесь с поддержкой для покупки пакета сообщений',
            noUsersInCourse:
                'Нет пользователей для отправки; все пользователи в этом курсе уже завершили его',
            youAreLeftWithQuota: 'У вас осталось',
            youNeed: 'а всего необходимо',
            toCompleteTheProcess: 'для завершения процесса',
        },
        send: 'Отправить',
    },
    SADeleteUsersModal: {
        title: 'Удалить пользователей',
        firstName: 'Имя',
        lastName: 'Фамилия',
        email: 'Email',
        phone: 'Телефон',
        employeeID: 'ID сотрудника',
        idNumber: 'Номер удостоверения',
        organizations: 'Организации',
        identifier: 'Идентификатор',
        message: (key, { userCount }) =>
            `Вы уверены, что хотите удалить следующих ${userCount} пользователей?`,
        deleteUsers: 'Удалить пользователей',
        fetchError: 'Ошибка при загрузке данных пользователей',
        deleteError: 'Ошибка при удалении пользователей',
        deleting: 'Удаление...',

        // Confirmation view
        confirmMessage: (key, {userCount}) => `Вы уверены, что хотите удалить ${userCount} пользователей?`,
        confirmHint: 'Пользователи, которые являются администраторами организаций, не будут удалены и будут показаны в отчете о результатах.',

        // Results view
        resultsTitle: 'Результаты удаления',
        successTitle: 'Удаление завершено успешно',
        noDeletedTitle: 'Пользователи не удалены',

        deletedUsersTitle: 'Удаленные пользователи',
        skippedUsersTitle: 'Пропущенные пользователи',

        // Result messages
        successMessageOnly: (key, {deleted}) => `Успешно удалено ${deleted} пользователей.`,
        noDeletedMessage: (key) => `Пользователи не удалены.`,

        skippedExplanationTitle: 'Почему пользователи не были удалены?',
        skippedExplanation: 'Следующие пользователи не были удалены, потому что они являются администраторами организаций или имеют другие ограничения. Чтобы удалить их, сначала удалите их права администратора из всех соответствующих организаций.',

        skipReason: 'Причина',
        reasons: {
            orgAdmin: 'Администратор организации',
            adminOf: 'Администратор',
            self: 'Нельзя удалить себя',
            notFound: 'Пользователь не найден',
            // Deletion protection reasons from backend
            cannot_delete_self: 'Нельзя удалить себя',
            cannot_delete_superadmin: 'Нельзя удалить суперадминистратора',
            cannot_delete_company_admin: 'Нельзя удалить администратора компании',
            cannot_delete_organizational_admin: 'Нельзя удалить администратора организации',
            different_company: 'Пользователь принадлежит другой компании',
            not_an_organizational_admin: 'Вы не администратор организации',
            not_admin_of_all_user_organizations: 'Вы не администратор всех организаций пользователя',
            generic_error: 'Пользователя нельзя удалить'
        }
    },
    SARemoveUser: {
        permanentlyDeleteUser: 'Удалить безвозвратно',
        deleteUserTitle: 'Безвозвратное удаление пользователя',
        deleteUserText:
            'Вы уверены, что хотите безвозвратно удалить пользователя',
        deleteOrgConfirm: 'Удалить пользователя безвозвратно',
    },
    SADeleteUsersPermanentlyModal: {
        title: 'Безвозвратное удаление пользователей',
        firstName: 'Имя',
        lastName: 'Фамилия',
        email: 'Электронная почта',
        phone: 'Телефон',
        employeeID: 'ID сотрудника',
        idNumber: 'Номер удостоверения',
        organizations: 'Организации',
        identifier: 'Идентификатор',
        warningTitle: 'Внимание! Необратимое действие',
        warningMessage: (key, {userCount}) => `Вы собираетесь безвозвратно удалить ${userCount} пользователей. Это действие нельзя отменить, и пользователи будут навсегда удалены из базы данных.`,
        confirmationRequired: 'Для подтверждения введите следующий текст:',
        confirmationText: 'удалить безвозвратно',
        confirmationPlaceholder: 'Введите "удалить безвозвратно" для подтверждения',
        deleteUsersPermanently: 'Удалить пользователей безвозвратно',
        cancel: 'Отмена',
        fetchError: 'Ошибка при загрузке данных пользователя',
        deleteError: 'Ошибка безвозвратного удаления пользователей',
        deleting: 'Удаление безвозвратно...',
        confirmationMismatch: 'Введенный текст не совпадает. Пожалуйста, введите "удалить безвозвратно" точно.',
    },
    automations: {
        title: 'Автоматизация',
        subTitle: 'Управление и настройки',
        addAutomation: 'Добавить автоматизацию',
        editAutomation: 'Редактировать автоматизацию',
        deleteAutomation: 'Удалить автоматизацию',
        automationName: 'Название автоматизации',
        automationDescription: 'Описание автоматизации',
        automationImage: 'Изображение автоматизации',
        automationCard: {
            editAutomation: 'Редактировать автоматизацию',
        },
        notifications: {
            title: 'Создать автоматизацию',
            subTitle: 'для планирования напоминаний',
        },
        createAutomationModal: {
            weWillSendNotificationTo: 'Мы вышлем напоминание всем, кто не завершил курс ',
            allOrganizations: 'Все организационные единицы',
            organizationOptions: {
                label: 'Какая организационная единица?',
                pleaseSelect:
                    'Пожалуйста, выберите организационную единицу, которой вы хотите отправить напоминание',
                error: 'Необходимо выбрать организационную единицу для отправки напоминания',
            },
            taskOptions: {
                label: 'Какое задание?',
                pleaseSelect: 'Пожалуйста, выберите задание, для которого вы хотите отправить напоминание',
                error: 'Необходимо выбрать курс для отправки напоминания',
            },
            selectHourLabel: 'В котором часу?',
            selectHourError: 'Необходимо выбрать время отправки напоминания',
            howManyDaysBefore: 'За сколько дней до окончания?',
            howManyDaysBeforeError:
                'Необходимо указать, за сколько дней до окончания отправить напоминание',
            nameLabel: 'Название автоматизации',
            descriptionLabel: 'Описание автоматизации',
            create: 'Создать автоматизацию',
        },
    },
    automationsTable: {
        columns: {
            automationName: 'Название автоматизации',
            description: 'Описание автоматизации',
            organization: 'Организационная единица',
            task: 'Задача',
            when: 'Когда?',
            status: 'Статус',
            how: 'Как отправляется?',
            delete: 'Удалить',
            edit: 'Редактировать',
        },
        automationTypeBadge: {
            oneTime: 'Перед окончанием',
            recurring: 'Периодическая'
        },
        status: {
            SCHEDULED: 'Запланировано',
            COMPLETED: 'Отправлено',
            sentAndNotSent: (key, { sent, notSent }) =>
                `Отправлено: ${sent}, не отправлено: ${notSent}`,
        },
        sendType: {
            SMS: 'SMS',
            EMAIL: 'Email',
            WHATSAPP: 'WhatsApp',
        },
        atHour: 'в',
        daysBefore: 'дней до даты окончания курса',
    },
    allOrganizations: 'Все организационные единицы',
    allSignDocs: 'Все задачи',
    confirmationModal: {
        confirm: 'Подтвердить',
        cancel: 'Отменить',
    },
    deleteAutomationModal: {
        title: 'Удалить автоматизацию',
        message: 'Вы уверены, что хотите удалить эту автоматизацию?',
        deleteAutomation: 'Удалить автоматизацию',
        automationName: 'Название автоматизации',
    },
    newDocSign: {
        buttonTitle: 'Создать новую задачу',
        modal: {
            title: 'Создать новую задачу',
            newVersionTitle: 'Создать новую версию',
            editSignDocTitle: 'Редактировать задачу',
            docNameLabel: {
                'REGULAR_COURSE': 'Название курса',
                'READ_AND_SIGN_DOC_PDF': 'Название документа',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Название видео',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Название видео',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Название видео',
                'CANVA_PRESENTATION': 'Название презентации',
                'EXAM': 'Название экзамена',
                'LEARNING_PATH': 'Название учебного пути',
                'PODCAST': 'Название подкаста',
                'AUDIO_FILE': 'Название аудиофайла',
                'FRONTAL_COURSE': 'Название фронтальной лекции',
                'ONLINE_COURSE': 'Название онлайн-курса',
                'PRESENTATION': 'Название презентации',
                'ARTICLE': 'Название статьи',
                'SURVEY': 'Название опроса',
                'LINK': 'Название ссылки',
                'UPLOAD_DOCUMENT': 'Название задачи',
            },
            docDescriptionLabel: {
                'REGULAR_COURSE': 'Описание документа',
                'READ_AND_SIGN_DOC_PDF': 'Описание документа',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Описание видео',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Описание видео',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Описание видео',
                'CANVA_PRESENTATION': 'Описание презентации',
                'EXAM': 'Описание экзамена',
                'LEARNING_PATH': 'Описание учебного пути',
                'PODCAST': 'Описание подкаста',
                'AUDIO_FILE': 'Описание аудиофайла',
                'FRONTAL_COURSE': 'Описание фронтальной лекции',
                'ONLINE_COURSE': 'Описание онлайн-курса',
                'PRESENTATION': 'Описание презентации',
                'ARTICLE': 'Описание статьи',
                'SURVEY': 'Описание опроса',
                'LINK': 'Описание ссылки',
                'UPLOAD_DOCUMENT': 'Описание задачи',
            },
            createButtonText: {
                'REGULAR_COURSE': 'Создать курс',
                'READ_AND_SIGN_DOC_PDF': 'Создать документ',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Создать задачу просмотра',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Создать задачу просмотра',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Создать задачу просмотра',
                'AUDIO_FILE': 'Создать задачу прослушивания',
                'CANVA_PRESENTATION': 'Создать презентацию',
                'EXAM': 'Создать экзамен',
                'LEARNING_PATH': 'Создать учебный путь',
                'PODCAST': 'Создать подкаст',
                'FRONTAL_COURSE': 'Создать фронтальную лекцию',
                'ONLINE_COURSE': 'Создать онлайн-курс',
                'PRESENTATION': 'Создать презентацию',
                'ARTICLE': 'Создать статью',
                'SURVEY': 'Создать опрос',
                'LINK': 'Создать ссылку',
                'UPLOAD_DOCUMENT': 'Создать задачу загрузки',
            },
            dropDocLabel: {
                'READ_AND_SIGN_DOC_PDF': 'Перетащите PDF-файл сюда или нажмите для выбора файла',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Перетащите видеофайл сюда или нажмите для выбора файла',
                'AUDIO_FILE': 'Перетащите аудиофайл сюда или нажмите для выбора файла',
                'UPLOAD_DOCUMENT': 'Перетащите файл сюда или нажмите для выбора файла',
            },
            examExtraSaveButton: 'Сохранить и продолжить редактирование вопросов',
            weezBeeCourseExtraSaveButton: 'Сохранить и продолжить редактирование курса',
            learningPathExtraSaveButton: 'Сохранить и продолжить редактирование учебного пути',
            surveyExtraSaveButton: 'Сохранить и продолжить редактирование опроса',
            createDocument: 'Создать документ',
            createExam: 'Создать экзамен',
            createLearningPath: 'Создать учебный путь',
            dropSignDocHere: 'Перетащите файл документа сюда или нажмите для выбора файла',
            selectSignDocType: 'Тип',
            linkUrl: 'Ссылка',
            youtubeLinkNotAllowed: 'Нельзя вводить ссылку Youtube',
            vimeoLinkNotAllowed: 'Нельзя вводить ссылку Vimeo',
            canvaLinkNotAllowed: 'Нельзя вводить ссылку Canva',
            invalidLink: 'Недействительная ссылка',
            notifyUsersOfNewTask: 'Отправить сообщение пользователям о новой задаче',
            notifyUsersOfNewTaskTooltip: 'Сообщение будет отправлено только пользователям, которые еще не получили уведомление об этой задаче',
            quotaWarning: {
                title: 'Недостаточно кредитов для сообщений',
                message: (key, { quotaNeeded, quotaAvailable, totalUsers }) => `Для уведомления ${totalUsers} пользователей необходимо ${quotaNeeded} сообщений, но доступно только ${quotaAvailable}.`,
                contactSupport: 'Пожалуйста, свяжитесь с поддержкой для покупки дополнительных сообщений или отключите уведомления, чтобы сохранить без отправки.',
                disableNotificationToSave: 'Отключите уведомления, чтобы сохранить документ',
            },
            forceCompletion: 'Обязательно для завершения',
            nonForceCompletion: 'Центр знаний',
            noDate: 'Без даты окончания',
            isMustDo: {
                label: 'Обязательно для соответствия',
                tooltip: 'Пользователи должны выполнить эту задачу, чтобы пройти внешнюю проверку соответствия'
            },
            allowFastForward: {
                WATCH_AND_SIGN_VIDEO_FILE: 'Разрешить перемотку вперед в видео',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'Разрешить перемотку вперед в видео',
                WATCH_AND_SIGN_VIMEO_LINK: 'Разрешить перемотку вперед в видео',
                AUDIO_FILE: 'Разрешить перемотку вперед в аудиофайле',
            },
            organizationAssignmentInfo: 'Вы сможете назначить задачу организационным подразделениям при редактировании задачи',
            assignToAllOrganizations: 'Назначить всем организационным подразделениям',
            removeFromAllOrganizations: 'Удалить из всех организационных подразделений',
            assignmentTabs: {
                organizations: 'Назначить организационным подразделениям',
                individualUsers: 'Назначить индивидуальным пользователям'
            },
            assignmentSubTabs: {
                allUsers: 'Все пользователи',
                selected: 'Выбранные',
                noSelectedUsers: 'Пользователи не выбраны'
            },
            recurring: {
                toggleLabel: 'Включить периодичность',
                toggleDescription: 'Автоматически создавать новые версии через регулярные интервалы',
                frequencyLabel: 'Периодичность',
                frequencyNote: 'Пользователи будут переназначены на новые версии по этому расписанию',
                nextVersionDate: 'Следующая версия будет создана',
                minimumFrequencyError: 'Минимальная периодичность - 1 месяц',
                nextVersionDateLabel: 'Дата следующей версии',
                transitionDisclaimer: 'Эта задача меняется с обычной на периодическую. Необходимо выбрать дату для следующей версии. Эта дата будет применена ко всем назначенным пользователям. После этой даты новые версии будут создаваться автоматически в соответствии с выбранной периодичностью. Вы можете изменить дату в любое время на странице управления версиями.',
            },
            groupType: {
                label: 'Частота',
                SEQUENTIAL: 'Периодический',
                PARALLEL: 'Без частоты'
            },
            status: {
                label: 'Статус',
                ACTIVE: 'Активный',
                ARCHIVED: 'В архиве'
            }
        },
    },
    signDocModal: {
        importUsers: {
            modalTitle: 'Импорт пользователей из файла',
            importFromFile: 'Импорт из файла',
            matchedUsers: 'Найденные пользователи',
            unmatchedRows: 'Ненайденные строки',
            addUsers: (key, {count}) => `Добавить ${count} пользователей`,
            noMatchesFound: 'Совпадающие пользователи не найдены',
            unmatchedRowsHint: 'Эти строки не соответствуют ни одному пользователю в системе. Проверьте правильность номеров телефонов.',
            processingFile: 'Обработка файла...',
            fileError: 'Ошибка чтения файла'
        }
    },
    signDocProgress: {
        notStarted: {
            READ_AND_SIGN_DOC_PDF: 'Я не прочитал',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Я не смотрел',
            WATCH_AND_SIGN_VIMEO_LINK: 'Я не смотрел',
            WATCH_AND_SIGN_VIDEO_FILE: 'Я не смотрел',
            AUDIO_FILE: 'Я не слушал',
            REGULAR_COURSE: 'Я не начинал',
            CANVA_PRESENTATION: 'Я не смотрел',
            EXAM: 'Я не начинал',
            LEARNING_PATH: 'Я не начинал',
            LINK: 'Я не смотрел',
            SURVEY: 'Я не начинал',
            WEEZBEE_COURSE: 'Я не начинал',
            UPLOAD_DOCUMENT: 'Я не загружал',
            FRONTAL_COURSE: 'Я не присутствовал',
            ONLINE_COURSE: 'Я не начинал',
        },
        inProgress: {
            READ_AND_SIGN_DOC_PDF: 'Я прочитал',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Я начал',
            WATCH_AND_SIGN_VIMEO_LINK: 'Я начал',
            WATCH_AND_SIGN_VIDEO_FILE: 'Я начал',
            AUDIO_FILE: 'Я слушал',
            REGULAR_COURSE: 'Я начал',
            CANVA_PRESENTATION: 'Я посмотрел',
            EXAM: 'Я начал',
            LEARNING_PATH: 'Я начал',
            LINK: 'Я посетил',
            SURVEY: 'Я начал',
            WEEZBEE_COURSE: 'Я начал',
            UPLOAD_DOCUMENT: 'Я загрузил',
            FRONTAL_COURSE: 'Зарегистрирован',
            ONLINE_COURSE: 'Я начал',
        },
        finished: {
            READ_AND_SIGN_DOC_PDF: 'Подписано!',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Завершено!',
            WATCH_AND_SIGN_VIMEO_LINK: 'Завершено!',
            WATCH_AND_SIGN_VIDEO_FILE: 'Завершено!',
            AUDIO_FILE: 'Завершено!',
            REGULAR_COURSE: 'Завершено!',
            CANVA_PRESENTATION: 'Подписано!',
            EXAM: 'Завершено!',
            LEARNING_PATH: 'Завершено!',
            LINK: 'Прочитано!',
            SURVEY: 'Завершено!',
            WEEZBEE_COURSE: 'Завершено!',
            UPLOAD_DOCUMENT: 'Одобрено',
            FRONTAL_COURSE: 'Завершено!',
            ONLINE_COURSE: 'Завершено!',
        }
    },
    signDocProgressMgmnt: {
        notStarted: 'Не открыто',
        inProgress: 'Открыто',
        finished: 'Подписано',
    },
    signDocPage: {
        title: {
            read: {
                sign: 'Подтверждение прочтения документа',
                noSign: 'Прочтение документа',
                knowledgeOnly: 'Прочтение документа',
            },
            watch: {
                sign: 'Подтверждение просмотра видео',
                noSign: 'Просмотр видео',
                knowledgeOnly: 'Просмотр видео',
            },
            canva: {
                sign: 'Подтверждение просмотра презентации',
                noSign: 'Просмотр презентации',
                knowledgeOnly: 'Просмотр презентации',
            },
        },
        subTitle: {
            read: {
                sign: 'Подтвердите и подпишите, что вы прочитали документ',
                noSign: 'Перечитать после подписания',
            },
            watch: {
                sign: 'Подтвердите и подпишите, что вы посмотрели видео',
                noSign: 'Пересмотреть после подписания',
            },
            canva: {
                sign: 'Просмотрите всю презентацию и подпишите для подтверждения',
                noSign: 'Пересмотреть после подписания',
            },
        },
        signatureTitle: {
            read: 'Подпишитесь, чтобы подтвердить, что вы прочли документ',
            watch: 'Подпишитесь, чтобы подтвердить, что вы посмотрели видео',
            canva: 'Подпишитесь, чтобы подтвердить, что вы просмотрели всю презентацию',
        },
        signatureSubtitle: {
            read: 'Для подтверждения прочтения документа, подпишитесь здесь',
            watch: 'Для подтверждения просмотра видео, подпишитесь здесь',
            canva: 'Для подтверждения просмотра презентации, подпишитесь здесь',
        },
        signatureSubtitleNotCompleted: {
            read: 'После прочтения появятся поле для подписи и кнопка подтверждения',
            watch: 'После просмотра появятся поле для подписи и кнопка подтверждения',
            canva: 'После завершения презентации появятся поле для подписи и кнопка подтверждения',
        },
        iApproveReadingTheDoc: {
            read: 'Я прочитал документ!',
            watch: 'Я посмотрел видео!',
            canva: 'Я просмотрел презентацию!',
        },
        clear: 'Очистить подпись',
    },
    signDocCard: {
        noDateSet: 'Дата не установлена',
        youAreDone: {
            READ_AND_SIGN_DOC_PDF: 'Вы подписали документ',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Вы посмотрели видео',
            WATCH_AND_SIGN_VIMEO_LINK: 'Вы посмотрели видео',
            WATCH_AND_SIGN_VIDEO_FILE: 'Вы посмотрели видео',
            AUDIO_FILE: 'Вы прослушали аудиофайл',
            REGULAR_COURSE: 'Вы завершили курс',
            CANVA_PRESENTATION: 'Вы посмотрели презентацию',
            EXAM: 'Вы завершили экзамен',
            WEEZBEE_COURSE: 'Вы завершили курс',
            LEARNING_PATH: 'Вы завершили учебный путь',
            LINK: 'Вы посмотрели ссылку',
            SURVEY: 'Вы завершили опрос',
            UPLOAD_DOCUMENT: 'Вы загрузили документ',
            FRONTAL_COURSE: 'Вы присутствовали на лекции',
            ONLINE_COURSE: 'Вы завершили онлайн-курс',
        },
        finishBy: {
            READ_AND_SIGN_DOC_PDF: (key, { finishByDate }) =>
                `Завершить до ${finishByDate}`,
            WATCH_AND_SIGN_YOUTUBE_LINK: (key, { finishByDate }) =>
                `Завершить до ${finishByDate}`,
            WATCH_AND_SIGN_VIMEO_LINK: (key, { finishByDate }) =>
                `Завершить до ${finishByDate}`,
            WATCH_AND_SIGN_VIDEO_FILE: (key, { finishByDate }) =>
                `Завершить до ${finishByDate}`,
            AUDIO_FILE: (key, { finishByDate }) =>
                `Прослушать до ${finishByDate}`,
            REGULAR_COURSE: (key, { finishByDate }) =>
                `Завершить до ${finishByDate}`,
            CANVA_PRESENTATION: (key, { finishByDate }) =>
                `Завершить до ${finishByDate}`,
            EXAM: (key, {finishByDate}) => `Необходимо завершить до ${finishByDate}`,
            WEEZBEE_COURSE: (key, {finishByDate}) => `Завершить до ${finishByDate}`,
            LEARNING_PATH: (key, {finishByDate}) => `Завершить до ${finishByDate}`,
            LINK: (key, {finishByDate}) => `Посетить до ${finishByDate}`,
            SURVEY: (key, {finishByDate}) => `Завершить до ${finishByDate}`,
            UPLOAD_DOCUMENT: (key, {finishByDate}) => `Загрузить до ${finishByDate}`,
            FRONTAL_COURSE: (key, {finishByDate}) => `Лекция: ${finishByDate}`,
            ONLINE_COURSE: (key, {finishByDate}) => `Онлайн-курс: ${finishByDate}`,
        },
        youAreDoneWatchAgain: {
            READ_AND_SIGN_DOC_PDF: 'Прочитать снова',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Посмотреть снова',
            WATCH_AND_SIGN_VIMEO_LINK: 'Посмотреть снова',
            WATCH_AND_SIGN_VIDEO_FILE: 'Посмотреть снова',
            REGULAR_COURSE: 'Посмотреть снова',
            CANVA_PRESENTATION: 'Посмотреть снова',
            FRONTAL_COURSE: 'Посмотреть детали снова',
            ONLINE_COURSE: 'Посмотреть снова',
        },
        goToCourse: {
            READ_AND_SIGN_DOC_PDF: 'Перейти к чтению',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Перейти к просмотру',
            WATCH_AND_SIGN_VIMEO_LINK: 'Перейти к просмотру',
            WATCH_AND_SIGN_VIDEO_FILE: 'Перейти к просмотру',
            AUDIO_FILE: 'Перейти к прослушиванию',
            REGULAR_COURSE: 'Перейти к курсу',
            CANVA_PRESENTATION: 'Перейти к просмотру',
            EXAM: 'Перейти к экзамену',
            WEEZBEE_COURSE: 'Перейти к курсу',
            LEARNING_PATH: 'Перейти к учебному пути',
            LINK: 'Перейти по ссылке',
            SURVEY: 'Перейти к опросу',
            UPLOAD_DOCUMENT: 'Перейти к странице загрузки',
            FRONTAL_COURSE: 'Задача уже выполнена',
            ONLINE_COURSE: 'Перейти к курсу',
        },
        disabledButtonTooltips: {
            locked: 'Задача заблокирована и в настоящее время недоступна',
            surveyNotRedoable: 'Опрос анонимный и уже завершен, поэтому его нельзя пройти снова',
            genericNotRedoable: 'Задача уже выполнена',
            frontalCourseDisabled: 'Посещаемость очных курсов отмечается только администратором'
        },
        examScore: (key, { score }) => `Оценка: ${score}`,
        completedByAdmin: 'Завершено администратором',
    },
    userSurveyAnswers: {
        modalTitle: (key, { userName }) => `Ответы пользователя ${userName}`,
        columns: {
            question: 'Вопрос',
            questionType: 'Тип вопроса',
            userAnswer: 'Ответ пользователя',
            isCorrect: 'Правильно'
        },
        notApplicable: 'Не применимо',
        noAnswer: 'Нет ответа',
        unknownQuestion: 'Неизвестный вопрос',
        unknownQuestionType: 'Неизвестный тип вопроса',
        unknownOption: 'Неизвестный вариант',
        invalidRating: 'Недопустимая оценка',
        loading: 'Загрузка ответов...',
        error: 'Ошибка загрузки ответов',
        noQuestions: 'Вопросы не найдены'
    },
    Errors_409: {
        storage_quota_error: (
            key,
            { bytesCompanyStorageQuota, bytesCompanyUsedStorage, bytesNewUsedStorage }
        ) => {
            const leftQuotaMB = (
                (bytesCompanyStorageQuota - bytesCompanyUsedStorage) /
                (1024 * 1024)
            ).toFixed(2) + ' MB';
            const bytesNewUsedStorageMB = (
                bytesNewUsedStorage /
                (1024 * 1024)
            ).toFixed(2) + ' MB';
            const bytesCompanyStorageQuotaMB = (
                bytesCompanyStorageQuota /
                (1024 * 1024)
            ).toFixed(2) + ' MB';
            return `Недостаточно доступного места в хранилище. Попробуйте удалить ненужные файлы или обратитесь к администратору системы. У вас осталось ${leftQuotaMB} из ${bytesCompanyStorageQuotaMB}, а размер файла, который вы пытаетесь загрузить, составляет ${bytesNewUsedStorageMB}.`;
        },
        missing_company_organization: 'Вы должны выбрать организационную единицу для пользователя',
        user_already_received_welcome_message: 'Пользователь уже получил приветственное сообщение',
        company_has_no_sms_quota: 'У компании недостаточно доступных SMS-кредитов, пожалуйста, свяжитесь со службой поддержки для покупки пакета сообщений',
        original_password_dont_match: 'Предоставленный пароль неверен',
        password_too_weak: 'Пароль недостаточно надёжный',
        organization_still_has_users: 'В организации все еще есть пользователи, которых нужно удалить или перенести в другую организацию',
    },
    signDocVersionManagement: {
        title: 'Управление версиями',
        managingVersionsFor: 'Управление версиями для',
        createNewVersionButton: 'Создать новую версию',
        allVersions: 'Все версии',
        archive: 'Переместить в архив',
        currentVersion: 'Текущая версия',
        versionNumber: 'Номер версии',
        versionDetails: 'Детали версии',
        viewDetails: 'Посмотреть детали',
        errorTitle: 'Ошибка загрузки версий',
        notFound: 'Документ не найден',
        notFoundDescription: 'Документ, который вы ищете, не существует или был удален',
        noVersions: 'Нет версий для отображения',
        created: 'Дата создания',
        createdBy: 'Создано пользователем',
        expiredAt: 'Срок истек',
        type: 'Тип',
        status: {
            label: 'Статус',
            ACTIVE: 'Активный',
            ARCHIVED: 'В архиве',
            SCHEDULED: 'Запланированный'
        },
        toggleStatus: 'Нажмите для переключения статуса (Активный/В архиве)',
        stats: {
            assigned: 'Назначено',
            completed: 'Завершено',
            inProgress: 'В процессе',
            completionRate: 'Процент завершения',
            totalUsers: 'Всего пользователей'
        },
        statistics: {
            progressDone: 'Прогресс выполнен',
            usersAssigned: 'Назначенные пользователи',
            usersCompleted: 'Пользователи, завершившие',
            usersInProgress: 'Пользователи в процессе'
        },
        viewStatistics: 'Просмотр статистики',
        userStatistics: 'Статистика пользователей',
        returnToData: 'Вернуться к данным',
        goToReports: 'Перейти к отчетам',
        edit: 'Редактировать',
        preview: 'Предпросмотр',
        tabs: {
            versions: 'Версии',
            recurringDetails: 'Детали повторения'
        },
        recurring: {
            title: 'Настройки повторения',
            notConfigured: 'Этот документ не настроен для повторения',
            frequency: 'Частота повторения',
            nextVersionDate: 'Дата следующей версии',
            editNextVersionDate: 'Редактировать дату следующей версии',
            changeDate: 'Изменить дату',
            everyXMonths: (key, { value }) => `Каждые ${value} месяц(ев)`,
            everyXYears: (key, { value }) => `Каждые ${value} год(лет)`,
            badge: 'Повторяющаяся',
        }
    },
    signDocPreviewPage: {
        title: 'Предпросмотр контента',
        loading: 'Загрузка предпросмотра...',
        errorTitle: 'Ошибка предпросмотра',
        errorDescription: 'Не удалось загрузить предпросмотр контента. Возможно, документ ещё не содержит загруженного контента.',
        noContent: 'Для этого документа нет доступного контента для предпросмотра.',
        backToVersions: 'Назад к версиям',
    },
    signDocTypes: {
        READ_AND_SIGN_DOC_PDF: 'PDF-документ для подписания',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'Ссылка Youtube для просмотра',
        WATCH_AND_SIGN_VIMEO_LINK: 'Ссылка VIMEO для просмотра',
        WATCH_AND_SIGN_VIDEO_FILE: 'Видеофайл для просмотра',
        REGULAR_COURSE: 'Курс',
        CANVA_PRESENTATION: 'Презентация Canva для просмотра',
        EXAM: 'Экзамен',
        FRONTAL_COURSE: 'Очное обучение',
        ONLINE_COURSE: 'Онлайн-обучение'
    },
    signDocTypesNotForCompletion: {
        READ_AND_SIGN_DOC_PDF: 'PDF-документ',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'Ссылка Youtube',
        WATCH_AND_SIGN_VIMEO_LINK: 'Ссылка VIMEO',
        WATCH_AND_SIGN_VIDEO_FILE: 'Видеофайл',
        REGULAR_COURSE: 'Курс',
        CANVA_PRESENTATION: 'Презентация Canva',
        EXAM: 'Экзамен',
        WEEZBEE_COURSE: 'Курс WeezBee',
        LEARNING_PATH: 'Путь обучения',
        AUDIO_FILE: 'Аудиофайл',
        LINK: 'Ссылка',
        SURVEY: 'Опрос',
        UPLOAD_DOCUMENT: 'Загрузить документ',
        FRONTAL_COURSE: 'Очное обучение',
        ONLINE_COURSE: 'Онлайн-обучение',
    },
    managementCourseList: {
        signDocButtonTitle: 'Создать задачу просмотра',
    },
    isCompanyAdmin: {
        makeAdmin: {
            title: 'Назначить администратором компании',
            message: 'Вы уверены, что хотите назначить этого пользователя администратором компании?',
            confirm: 'Назначить администратором компании',
            button: 'Назначить администратором компании',
        },
        removeAdmin: {
            title: 'Снять права администратора компании',
            message: 'Вы уверены, что хотите снять права администратора компании с этого пользователя?',
            confirm: 'Снять права администратора компании',
            button: 'Снять права администратора компании',
        },
        userName: 'Имя пользователя',
    },
    general: {
        saveChanges: 'Сохранить изменения',
        close: 'Закрыть',
        cancel: 'Отмена',
        save: 'Сохранить',
        deleteConfirm: 'Подтвердить удаление?',
        delete: 'Удалить',
        areYouSure: 'Вы уверены?',
        copyOf: 'Копия',
        duplicating: 'Дублирование...',
        next: 'Далее',
        back: 'Назад',
    },
    knowledgeCenter: {
        title: 'Центр знаний',
        subTitle: 'Вся информация в одном месте',
    },
    operation: {
        title: 'Операционная',
        subTitle: 'Вся операционная информация в одном месте',
    },
    adminUsersTable: {
        columns: {
            firstName: 'Имя',
            lastName: 'Фамилия',
            email: 'Email',
            phone: 'Телефон',
            roles: 'Роли',
            identifier: 'Идентификатор',
            managerOfOrganizations: 'Администратор в организационных единицах',
            id: 'ID',
            edit: 'Редактировать',
            isCompanyAdmin: 'Админ компании',
            isCompanyAdminYes: 'Да',
            isCompanyAdminNo: 'Нет',
        },
        addAdminUser: 'Добавить администратора',
    },
    editAdminUserModal: {
        title: 'Назначить администратора',
        titleEdit: 'Редактировать администратора',
        sendWelcomeMessage: 'Отправить приветственное сообщение администратору',
        save: 'Сохранить изменения',
        selectOrganizationalUnits: 'Поиск организационных единиц',
        searchUser: 'Поиск пользователя',
        isCompanyAdmin: 'Админ компании',
        companyAdminWillBeAdminOfAllOrgs:
            'Админ компании будет администратором всех организационных единиц',
        selectAllOrgs: 'Выбрать все организационные единицы',
    },
    autoComplete: {
        search: 'Поиск',
        selectAll: 'Выбрать все',
        noOptions: 'Ничего не найдено',
    },
    UserIconMenu: {
        settings: 'Настройки',
    },
    deletedUserTable: {
        emailNotAssigned: 'Электронная почта не введена',
        columns: {
            firstName: 'Имя',
            lastName: 'Фамилия',
            phoneNumber: 'Мобильный телефон',
            email: 'Электронная почта',
            firstLoginDate: 'Дата регистрации',
            deletedDate: 'Дата удаления',
            userDetails: 'Данные пользователя'
        },
    },
    deletedUsersPage: {
        buttons: {
            downloadCsv: 'Экспорт в CSV',
            downloadCsvForOrganizations: 'Экспорт удаленных пользователей для выбранных организационных единиц',
            restoreUsers: 'Восстановить пользователей',
        }
    },
    restoreUsersModal: {
        title: 'Восстановление удалённых пользователей',
        resultsTitle: 'Результаты восстановления',
        confirmMessage: (key, {userCount}) => `Вы собираетесь восстановить ${userCount} пользователя(ей). Продолжить?`,
        confirmHint: 'Восстановленные пользователи будут переназначены в их прежние организации.',
        restoreUsers: 'Восстановить пользователей',
        restoring: 'Восстановление...',
        restoreError: 'Произошла ошибка при восстановлении пользователей. Пожалуйста, попробуйте ещё раз.',
        successMessage: (key, {restored}) => `Успешно восстановлено ${restored} пользователя(ей)`,
        noRestoredMessage: 'Ни один пользователь не восстановлен',
        restoredUsersTitle: 'Восстановленные пользователи',
        skippedUsersTitle: 'Пропущенные пользователи',
        skippedExplanationTitle: 'Почему некоторые пользователи были пропущены?',
        skippedExplanation: 'Некоторых пользователей не удалось восстановить из-за внутренних ошибок. Попробуйте ещё раз или обратитесь в поддержку, если проблема сохранится.',
        firstName: 'Имя',
        lastName: 'Фамилия',
        email: 'Электронная почта',
        employeeID: 'Идентификатор сотрудника',
        idNumber: 'Идентификационный номер',
        organizations: 'Организации',
        skipReason: 'Причина',
        reasons: {
            restore_failed: 'Произошла ошибка при восстановлении',
        },
    },
    deletedUserModal: {
        title: 'Документы и курсы, связанные с',
        columns: {
            docName: 'Название задачи',
            status: 'Статус',
            completedOnDate: 'Дата завершения',
            type: 'Тип задачи',
        },
        status: {
            finished: 'Завершено',
            inProgress: 'В процессе',
            notStarted: 'Не начато',
            signed: "Подписано"
        },
        signDocData: {
            unCompletedCourse: 'Задача не выполнена',
        }
    },
    userDetailsModal: {
        learningPath: {
            expandTasks: 'Показать задачи учебного пути',
            collapseTasks: 'Скрыть задачи учебного пути'
        },
        progressSummary: {
            title: 'Сводка прогресса',
            completed: 'Завершено',
            inProgress: 'В процессе',
            notStarted: 'Не начато',
            tasksCompleted: 'задачи завершены'
        },
        statusFilter: {
            archived: 'В архиве'
        },
        archivedTag: 'Архив',
        actions: {
            updateExpiryDate: 'Обновить дату истечения',
            declineApproval: 'Отклонить одобрение',
            markAttended: 'Отметить как присутствовал',
            markNoShow: 'Отметить как не явился'
        }
    },
    FirstLoginModal: {
        title: 'Как здорово начать учиться вместе!',
        content: 'Вам нужно выполнить открытые задания на главном экране до указанной даты.\n' +
            'Удачи!',
        takeMeHome: 'Отлично, ведите на главный экран!'
    },
    organizationalUnitTable: {
        columns: {
            organizationalUnitName: 'Название организационного подразделения',
            createAt: 'Дата создания',
            details: 'Детали',
            delete: 'Удалить',
            userCount: 'Количество пользователей',
            updateOrgName: 'Обновить названия организационных единиц',
        },
        removeOrgCell: {
            columns: {
                firstName: 'Имя',
                lastName: 'Фамилия',
                organizationChange: 'Изменить организационное подразделение',
                deleteUser: 'Удалить пользователя'
            },
            modalNotAllowedDeleteTitle: 'Чтобы удалить организационное подразделение, необходимо переназначить всех пользователей в другое подразделение или удалить их.',
            modalAllowDeleteTitle: 'В организации нет пользователей, вы можете ее удалить.',
            button: 'Удалить организационное подразделение',
            tooltipMessage: 'Чтобы удалить организацию, необходимо удалить или переназначить всех пользователей.',
            alertErrorDeleteOrgTitle: 'Ошибка при удалении организации',
            failedDeleteOrgError: 'Не удалось удалить организацию, извините! Пожалуйста, обновите страницу и попробуйте снова.'
        },
        editOrgNameCell: {
            button: 'Обновить название организационной единицы',
        }
    },
    questionnaire: {
        buttons: {
            continueToQuestionPool: 'Сохранить и продолжить редактирование вопросов',
        },
        modal: {
            title: 'Создание нового опроса',
            passGrade: 'Проходной балл',
            timeToFinish: 'Время на экзамен',
            canUserReview: 'Разрешить экзаменуемому просматривать ответы',
            allowedTries: 'Допустимое количество попыток'
        }
    },
    questionnaireQuestions: {
        validation: {
            modalTitle: 'Пожалуйста, исправьте следующие ошибки перед сохранением экзамена',
            questionIndexError: 'Ошибка в вопросе номер',
            closeAndFix: 'Закрыть и исправить',
            navigateToQuestion: 'Перейти к вопросу',
            minimumOptions: 'Менее двух вариантов с правильным ответом на вопрос',
            noCorrectAnswer: 'Правильный ответ не был выбран для вопроса',
            duplicateOptions: 'Есть два варианта с одинаковыми ответами',
        },
        aiLoadingTexts: {
            loading: 'Генерируем вопросы для вас...',
            pleaseWait: 'Пожалуйста, подождите...',
            testWillBeReadySoon: 'Ваш экзамен скоро будет готов...',
            aBitMorePatience: 'Ещё немного терпения...',
            itMightTakeABitLongerButItsWorthIt: 'Это может занять немного больше времени, но оно того стоит...',
        },
        tooltip: {
            pleaseFillSubject: 'Пожалуйста, заполните тему экзамена',
        },
        placeHolders: {
            subject: '*Тема экзамена',
            description: 'Краткое описание',
            question: 'Вопрос',
            FREE_TEXT: 'Краткий текст ответа',
            option: 'Вариант',
            NO_ANSWER: 'Этот раздел предназначен только для информации и не требует ответа',
            questionCount: 'Количество вопросов',
        },
        question: 'Вопрос',
        FREE_TEXT: 'Краткий текст ответа',
        option: 'Вариант',
        NO_ANSWER: 'Этот раздел предназначен только для информации и не требует ответа',
        messages: {
            deleteLastQuestion: 'Нельзя удалить последний вопрос',
        },
        headers: {
            poolQuestion: 'Редактировать экзамен',
            poolQuestionSubTitle: 'Количество вопросов, созданных для экзамена',
        },
        buttons: {
            addOption: 'Добавить вариант +',
            saveQuestions: 'Сохранить вопросы',
            saveQuestionsSubTitle: 'Сохранить все вопросы в экзамене',
            genAIQuestions: 'Создать вопросы с помощью ИИ',
        },
        aiModal: {
            questionQuantityLabel: 'Количество вопросов для создания',
        },
        questionOptions: {
            MULTIPLE_CHOICE: 'Один вариант ответа',
            CHECKBOX: 'Несколько вариантов ответа',
            FREE_TEXT: 'Открытый вопрос',
            NO_ANSWER: 'Краткий абзац',
            RATING_SCALE: 'Шкала оценки',
        },
        survey: {
            anonymousToggle: 'Анонимный опрос',
            anonymousDescription: 'При включении данные пользователей, заполнивших опрос, не будут сохранены',
            ratingScale: {
                title: 'Настройки шкалы оценки',
                minValue: 'Минимальное значение',
                maxValue: 'Максимальное значение',
                minLabel: 'Минимальная метка',
                maxLabel: 'Максимальная метка',
                defaultMinLabel: 'Не удовлетворен',
                defaultMaxLabel: 'Очень удовлетворен',
                previewTitle: 'Предпросмотр',
            }
        },
        addImage: 'Добавить изображение к вопросу',
        hasImage: 'Вопрос содержит изображение',
        dropImageOrClick: 'Перетащите изображение сюда или нажмите для выбора',
        uploading: 'Загрузка изображения...',
        supportedFormats: 'Поддерживаемые форматы',
        deleteImageTitle: 'Удалить изображение',
        confirmDeleteImage: 'Вы уверены, что хотите удалить изображение?',
        errors: {
            invalidImageType: 'Неподдерживаемый тип файла. Пожалуйста, загрузите изображение в формате JPG, PNG, GIF или WEBP',
            imageTooLarge: 'Размер файла превышает 10 МБ',
            uploadFailed: 'Не удалось загрузить изображение',
            deleteFailed: 'Не удалось удалить изображение',
        }
    },

    questionnaireSession: {
        imageLoadError: 'Не удалось загрузить изображение',
        modal: {
            finishExam: 'Вы уверены, что хотите завершить экзамен?',
            finishExamTitle: 'Завершение экзамена',
            finishExamWithUnansweredQuestions: 'Вы уверены, что хотите закончить? Есть неотвеченные вопросы',
            closeAndReturnToTest: 'Вернуться к экзамену'
        },
        finishModal: {
            congratsTitle: 'Молодец!',
            congratsMessage: 'Вы успешно сдали экзамен',
            oopsTitle: 'Ой...',
            oopsMessage: 'Похоже, вы не сдали экзамен',
        },
        buttons: {
            previousQuestion: 'Предыдущий вопрос',
            nextQuestion: 'Следующий вопрос',
            finishExam: 'Завершить экзамен',
            congratsModal: 'Отлично, отведите меня на главный экран',
            oopsBackToHomePage: 'Назад на главный экран',
        },
        errors: {
            notAllQuestionsAnswered: 'Не на все вопросы даны ответы. Вы уверены, что хотите закончить?',
        },
    },
    surveySession: {
        finishModal: {
            congratsTitle: 'Большое спасибо!',
            congratsMessage: 'Большое спасибо за участие в опросе! \n Ваш вклад очень важен для нас.',
        },
        defaultTitle: "Опрос",
        buttons: {
            previousQuestion: "Предыдущий вопрос",
            nextQuestion: "Следующий вопрос",
            finishSurvey: "Завершить опрос",
            congratsModal: 'Отлично, отведите меня на главный экран',
        },
        placeHolders: {
            FREE_TEXT: 'Ваш ответ',
        },
        modal: {
            finishSurveyTitle: "Завершение опроса",
            finishSurvey: "Вы уверены, что хотите завершить опрос? Вы можете вернуться и изменить ответы перед завершением.",
            closeAndReturnToSurvey: "Вернуться к опросу"
        },
        success: {
            title: "Большое спасибо!",
            anonymousMessage: "Ваши ответы были сохранены анонимно",
            identifiedMessage: "Ваши ответы были успешно сохранены в системе",
            thankYou: "Спасибо за участие в опросе! Ваш вклад очень важен для нас.",
            anonymousConfirmation: "Ваша информация была сохранена анонимно, и вас невозможно идентифицировать",
            goHome: "Вернуться на главную страницу"
        }
    },
    surveyInstruction: {
        title: 'Прежде чем начать, несколько важных моментов...',
        info1:(key, {numberOfQuestions}) =>  `Опрос состоит из ${numberOfQuestions} вопросов`,
        info2: 'Мы будем рады услышать ваше мнение',
        info3: 'Участие в опросе добровольное',
        info4: 'Вы можете пропустить вопросы, на которые не хотите отвечать',
        anonymous: "Опрос полностью анонимный",
        anonymousNotice: "Ваши ответы будут сохранены анонимно, и невозможно будет узнать, какие ответы вы дали",
        thankYou: 'Большое спасибо за ваше участие!',
        startButton: 'Начать опрос'
    },
    questionnaireInstruction: {
        title: 'Прежде чем начать, несколько важных моментов...',
        info1:(key, {numberOfQuestions}) =>  `Экзамен состоит из ${numberOfQuestions} вопросов`,
        info2:(key, {passGrade}) =>  `Проходной балл для экзамена - ${passGrade}`,
        info3: 'Необходимо ответить на все вопросы перед отправкой',
        successInfo: 'Сдали? ',
        failInfo: 'Не сдали? ',
        info4: 'Как здорово, вы завершили задание. ',
        info5: 'Необходимо пересдать экзамен',
        goodLuck: 'Удачи!',
        startButton: 'Начать'
    },
    weezbeeCourse: {
        addContent: 'Добавить контент',
        contentType: 'Тип контента',
        contentTypes: {
            text: 'Текст',
            video: 'Видео',
            image: 'Изображение',
            quiz: 'Тест',
            pdf: 'PDF'
        },
        orientationOverlay: {
            title: 'Пожалуйста, поверните устройство',
            message: 'Для лучшего просмотра, пожалуйста, поверните устройство в горизонтальное положение.'
        },
        fullscreenPrompt: {
            title: 'Показать курс в полноэкранном режиме',
            buttonText: 'Войти в полноэкранный режим',
            errors: {
                permissionDenied: 'Доступ запрещен. Пожалуйста, попробуйте снова, нажав на кнопку полноэкранного режима.',
                generic: 'Ошибка полноэкранного режима: {message}'
            }
        },
        chapterPanel: {
            title: 'Главы для выполнения',
            generating: 'Генерация...',
            aiCreating: 'ИИ создает эту главу...',
            deleteChapter: 'Удалить главу',
            duplicateChapter: 'Дублировать главу',
            copySuffix: '(копия)',
        },
        question: {
            defaultText: 'Введите ваш вопрос здесь',
            tryAgain: 'Упс, неправильный ответ. Попробуйте еще раз!',
            submitAnswer: 'Отправить ответ',
            correct: 'Правильно!',
            incorrect: 'Неправильно',
        },
        navigation: {
            back: 'Назад',
            next: 'Далее'
        },
        aiGeneration: {
            generateCourse: 'Создать курс с помощью ИИ',
            courseLengthMinutes: 'Длительность курса (минуты)',
            courseLengthMinutesHelp: 'Введите значение от 5 до 30 минут',
            descriptionPlaceholder: 'Краткое описание курса...',
            tooltip: {
                pleaseEnterDescription: 'Пожалуйста, введите описание курса (5-150 символов)',
                pleaseEnterValidCourseLength: 'Пожалуйста, введите корректную длительность курса (5-30 минут)'
            },
            loadingTexts: {
                loading: 'Создаем курс для вас...',
                pleaseWait: 'Пожалуйста, подождите...',
                courseWillBeReadySoon: 'Ваш курс скоро будет готов...',
                aBitMorePatience: 'Еще немного терпения...',
                itMightTakeABitLongerButItsWorthIt: 'Это может занять еще несколько секунд, но оно того стоит...',
            },
        },
        aiWizard: {
            openWizardButton: 'Создать курс с помощью ИИ',
            wizardTitle: 'Мастер создания курса с ИИ',
            step1Label: 'Детали курса',
            step2Label: 'Выбор шаблона',
            subjectLabel: 'Тема курса',
            subjectPlaceholder: 'Введите основную тему курса...',
            promptLabel: 'Дополнительные инструкции для ИИ (необязательно)',
            promptPlaceholder: 'Укажите конкретные инструкции для ИИ...',
            uploadFileButton: 'Загрузить справочный файл (PDF/TXT)',
            fileUploaded: 'Файл загружен: {fileName}',
            removeFile: 'Удалить файл',
            characterLimitExceeded: 'Превышен лимит символов. Пожалуйста, сократите содержимое.',
            subjectRequired: 'Тема курса обязательна',
            validationError: 'Пожалуйста, исправьте ошибки перед продолжением',
            fileTooLarge: 'Файл слишком большой. Максимальный размер: {maxSize}MB',
            unsupportedFileType: 'Неподдерживаемый тип файла. Пожалуйста, загрузите PDF или TXT файл',
            fileReadError: 'Ошибка чтения файла. Пожалуйста, попробуйте снова',
            extractingFile: 'Извлечение текста из файла...',
            generateButton: 'Создать курс',
            generatingButton: 'Создание...',
        },
        content: {
            title: 'Заголовок',
            description: 'Описание',
            text: 'Текстовый контент',
            videoUrl: 'URL видео',
            addQuestion: 'Добавить вопрос',
            question: 'Вопрос',
            option: 'Вариант {number}',
            correctAnswer: 'Правильный ответ'
        },
        editor: {
            pagination: {
                pageInfo: (key, {current, total}) => `Страница ${current} из ${total}`
            },
            backgroundSelector: {
                image: 'Изображение',
                video: 'Видео'
            },
            title: 'Редактор курса',
            addSection: 'Добавить раздел',
            editSection: 'Редактировать раздел',
            preview: 'Предпросмотр',
            switchToViewMode: 'Переключиться в режим просмотра',
            switchToEditMode: 'Переключиться в режим редактирования',
            enterFullscreen: 'Полный экран',
            exitFullscreen: 'Выйти из полного экрана',
            saveCourse: 'Сохранить курс',
            saveCourseSubTitle: 'Нажмите, чтобы сохранить курс',
            previewMode: 'Режим просмотра',
            editMode: 'Режим редактирования',
            templateMode: 'Режим шаблона',
            courseMode: 'Режим курса',
            switchToTemplateMode: 'Переключиться в режим шаблона',
            switchToCourseMode: 'Переключиться в режим курса',
            templateDetails: 'Конфигурация шаблона курса',
            templateName: 'Имя шаблона',
            templateSubject: 'Категория / Предметная область',
            templateDescription: 'Описание шаблона',
            templateTags: 'Теги (через запятую)',
            templatePublic: 'Общедоступный',
            templateReady: 'Готов к использованию',
            saveTemplate: 'Сохранить шаблон',
            templateValidationError: 'Название шаблона и тема обязательны',
            templateSaved: 'Шаблон успешно сохранен!',
            templateUpdated: 'Шаблон успешно обновлен!',
            templateSaveError: 'Ошибка при сохранении шаблона. Пожалуйста, попробуйте снова.',
            templateCreateError: 'Ошибка при создании нового шаблона. Пожалуйста, попробуйте снова.',
            fetchError: 'Ошибка при загрузке курса или шаблона. Пожалуйста, попробуйте снова.',
            defaultCourseTitle: 'Курс',
            defaultCourseDescription: '',
            templateNamePlaceholder: 'Введите описательный заголовок для этого шаблона',
            templateSubjectPlaceholder: 'Например: Обучение безопасности, Адаптация, Лидерство',
            templateDescriptionPlaceholder: 'Предоставьте подробное описание того, что охватывает этот шаблон и для кого он предназначен',
            templateTagsPlaceholder: 'Добавьте ключевые слова, которые помогут пользователям найти этот шаблон (через запятую)',
            templateSelectorTitle: 'Создать или выбрать шаблон',
            createNewTemplate: 'Создать новый шаблон',
            createNewTemplateDesc: 'Начните с пустого шаблона и создайте его с нуля.',
            createTemplate: 'Создать шаблон',
            selectExistingTemplate: 'Выбрать существующий шаблон',
            selectExistingTemplateDesc: 'Выберите из существующих шаблонов для редактирования.',
            browseTemplates: 'Просмотреть шаблоны',
            publicAssetBank: 'Банк общедоступных ресурсов',
            publicAssetBankDescription: 'Ресурсы, добавленные здесь, будут доступны для всех шаблонов',
            uploadPublicAsset: 'Загрузить общедоступный ресурс',
            publicAssetUploaded: 'Общедоступный ресурс успешно загружен!',
            publicAssetUploadError: 'Ошибка при загрузке общедоступного ресурса. Пожалуйста, попробуйте снова.',
            templateAssetName: 'Ресурс шаблона',
            templateAssetDescription: 'Загружено из редактора шаблонов',
            componentBank: {
                title: 'Банк компонентов',
                description: 'Перетащите или нажмите для добавления компонентов',
                text: {
                    name: 'Текст',
                    description: 'Простой текстовый компонент'
                },
                bullets: {
                    name: 'Пункты',
                    description: 'Компонент списка пунктов'
                },
                logo: {
                    name: 'Логотип',
                    description: 'Компонент логотипа компании',
                    missingLogo: 'Логотип компании отсутствует'
                },
                image: {
                    name: 'Изображение',
                    description: 'Компонент изображения'
                },
                video: {
                    name: 'Видео',
                    description: 'Компонент видео'
                },
                shape: {
                    name: 'Фигура',
                    description: 'Компонент базовых фигур'
                },
                question: {
                    name: 'Вопрос',
                    description: 'Компонент интерактивного вопроса'
                }
            },
            chapterEditor: {
                title: 'Редактор глав',
                description: 'Редактировать содержание главы',
                contentTitle: 'Холст',
                canvasDescription: 'Перетащите компоненты на холст и свободно разместите их',
                emptyState: 'Компоненты еще не добавлены. Перетащите компоненты из банка или нажмите для добавления.',
                removeComponent: 'Удалить компонент'
            },
            textComponent: {
                placeholder: 'Введите текст здесь...',
                emptyState: 'Нажмите для добавления текста'
            },
            bulletsComponent: {
                placeholder: 'Введите текст пункта...',
                emptyState: 'Пустой пункт',
                removeBullet: 'Удалить пункт',
                addBullet: 'Добавить пункт'
            },
            logoComponent: {
                altText: 'Логотип компании',
                missingLogo: 'Логотип компании отсутствует',
                borderRadius: 'Радиус границы',
                backgroundColor: 'Цвет фона',
                opacity: 'Прозрачность'
            },
            imageComponent: {
                altText: 'Изображение',
                placeholder: 'Нажмите для добавления изображения',
                selectorTitle: 'Выберите изображение',
                uploadNew: 'Загрузить новое',
                imageBank: 'Банк изображений',
                loading: 'Загрузка...',
                emptyBank: 'В банке нет изображений',
                cancel: 'Отмена',
                enterUrl: 'Ввести URL',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'Отправить',
                changeSource: 'Изменить изображение'
            },
            backgroundImageComponent: {
                altText: 'Фоновое изображение',
                placeholder: 'Нажмите для добавления фонового изображения',
                selectorTitle: 'Выберите фоновое изображение',
                uploadNew: 'Загрузить новое',
                imageBank: 'Банк изображений',
                loading: 'Загрузка...',
                emptyBank: 'В банке нет изображений',
                cancel: 'Отмена',
                enterUrl: 'Ввести URL',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'Отправить',
                changeSource: 'Изменить фоновое изображение'
            },
            videoComponent: {
                altText: 'Видео',
                placeholder: 'Нажмите для добавления видео',
                selectorTitle: 'Выберите видео',
                uploadNew: 'Загрузить новое',
                videoBank: 'Банк видео',
                loading: 'Загрузка...',
                emptyBank: 'В банке нет видео',
                cancel: 'Отмена',
                enterUrl: 'Ввести URL',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'Отправить',
                changeSource: 'Изменить видео',
                errorTitle: 'Ошибка загрузки видео',
                errorMessage: 'Не удалось загрузить видео. Пожалуйста, загрузите новое видео или выберите другое из банка видео.',
                retry: 'Повторить',
                selectAnother: 'Выбрать другое видео',
                edit: 'Редактировать'
            },
            shapeComponent: {
                emptyState: 'Нажмите для выбора фигуры',
                rectangle: 'Прямоугольник',
                circle: 'Круг',
                triangle: 'Треугольник',
                star: 'Звезда'
            },
            title: {
                label: 'Заголовок',
                defaultValue: 'Новая глава'
            },
            description: {
                label: 'Описание',
                defaultValue: 'Описание главы'
            },
            headTitle: {
                label: 'Главный заголовок',
                defaultValue: 'Новая глава'
            },
            textContent: {
                label: 'Текстовый контент',
                defaultValue: 'Введите ваш контент здесь'
            },
            bullets: {
                label: 'Пункты',
                remove: 'Удалить',
                add: 'Добавить пункт',
                addPlaceholder: 'Добавить новый пункт...',
                defaultValue1: 'Пункт 1',
                defaultValue2: 'Пункт 2',
                defaultValue3: 'Пункт 3'
            },
            color: {
                placeholder: '#000000'
            },
            component: {
                borderRadius: 'Радиус границы',
                backgroundColor: 'Цвет фона',
                opacity: 'Прозрачность',
                textDirection: 'Направление текста',
                leftToRight: 'Слева направо',
                rightToLeft: 'Справа налево',
                pixelUnit: 'пикс',
                percentUnit: '%',
                colorValue: (key, { color }) => color,
                backgroundColorValue: (key, { color }) => color,
                borderRadiusAll: 'Все'
            },
            editorDrawer: {
                title: 'Редактировать компонент',
                closeButton: 'Закрыть',
                description: 'Настройте выбранный компонент',
                typography: 'Типографика',
                textFormatting: 'Форматирование текста',
                fontSize: 'Размер шрифта',
                textColor: 'Цвет текста',
                shapeType: 'Тип фигуры',
                shapeColor: 'Цвет фигуры',
                shapeOpacity: 'Прозрачность фигуры',
                borderWidth: 'Ширина границы',
                borderColor: 'Цвет границы',
                border: 'Граница',
                style: 'Стиль',
                background: 'Фон'
            },
            backgroundImage: {
                label: 'Фоновое изображение',
                placeholder: 'Введите URL изображения',
                uploadButton: 'Загрузить изображение',
                previewAlt: 'Предпросмотр фона',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=Неверный+URL+изображения'
            },
            logoImage: {
                label: 'Логотип',
                placeholder: 'Введите URL логотипа',
                uploadButton: 'Загрузить логотип',
                previewAlt: 'Предпросмотр логотипа',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=Неверный+URL+логотипа'
            },
            backgroundImageEditor: {
                title: 'Редактировать фоновое изображение',
                opacity: 'Прозрачность',
                backgroundColor: 'Цвет фона',
                transparent: 'Прозрачный',
                save: 'Сохранить изменения',
                remove: 'Удалить фоновое изображение',
                cancel: 'Отмена'
            },
            backgroundVideoEditor: {
                title: 'Редактировать фоновое видео',
                opacity: 'Прозрачность',
                backgroundColor: 'Цвет фона',
                transparent: 'Прозрачный',
                save: 'Сохранить изменения',
                remove: 'Удалить фоновое видео',
                cancel: 'Отмена'
            },
            backgroundVideoComponent: {
                changeSource: 'Изменить источник видео',
                enterUrl: 'Введите URL видео',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'Применить',
                cancel: 'Отмена',
                uploadNew: 'Загрузить новое видео',
                loading: 'Загрузка...',
                videoBank: 'Банк видео',
                backgroundVideoBank: 'Банк фонового видео',
                emptyBank: 'В банке видео не найдено видео.'
            },
            videoUrl: {
                label: 'URL видео',
                placeholder: 'Введите URL YouTube или видео'
            },
            // Template selection
            templateSelectionInstruction: 'Выберите шаблон для новой главы:',
            featureBadges: {
                video: 'Видео',
                bullets: 'Пункты',
                textContent: 'Текстовый контент',
                'text-content': 'Текстовый контент',
                heading: 'Заголовок'
            }
        },
        templateBank: {
            title: 'Выберите шаблон',
            description: 'Выберите шаблон для новой главы',
            closeButton: 'Закрыть банк шаблонов',
            selectTemplate: (key, { templateName }) => `Выбрать шаблон ${templateName}`,
            directionSelection: 'Выберите направление шаблона:',
            ltrDirection: 'Направление слева направо',
            rtlDirection: 'Направление справа налево',
            ltrLabel: 'LTR',
            rtlLabel: 'RTL',
            templates: {
                standardSlide: {
                    name: 'Стандартный слайд',
                    description: 'Стандартный слайд с логотипом, заголовком, текстом справа и изображением слева'
                },
                videoFocused: {
                    name: 'Фокус на видео',
                    description: 'Слайд с большим видео в центре и поясняющим текстом ниже'
                },
                bulletPoints: {
                    name: 'Ключевые пункты',
                    description: 'Слайд, сфокусированный на ключевых пунктах важной информации'
                },
                centeredImage: {
                    name: 'Центральное изображение',
                    description: 'Слайд с большим центральным изображением и подписью ниже'
                },
                textAndBullets: {
                    name: 'Текст и пункты',
                    description: 'Слайд с текстом слева и ключевыми пунктами справа'
                },
                videoAndBullets: {
                    name: 'Видео и пункты',
                    description: 'Слайд с видео слева и ключевыми пунктами справа'
                },
                twoColumnImage: {
                    name: 'Два изображения рядом',
                    description: 'Слайд с двумя изображениями рядом и подписью ниже'
                },
                threeColumnText: {
                    name: 'Три текстовые колонки',
                    description: 'Слайд с тремя текстовыми колонками для сравнения или перечисления связанной информации'
                },
                imageGallery: {
                    name: 'Галерея изображений',
                    description: 'Слайд с четырьмя изображениями, расположенными в сетке, с подписью ниже'
                },
                videoWithOverlay: {
                    name: 'Видео с текстовым наложением',
                    description: 'Слайд с видео и текстовым наложением для выделения ключевых моментов'
                },
                titleWithBackground: {
                    name: 'Заголовок на фоне изображения',
                    description: 'Слайд с заголовком и текстом на фоне изображения для драматического эффекта'
                }
            },
            content: {
                slideTitle: 'Заголовок слайда',
                loremIpsum: 'Лорем ипсум долор сит амет, консектетур адипискинг элит. Нуллам ауктор, нисл эгет ултрициес тинцидунт, нисл нисл аликуам нисл, эгет ултрициес нисл нисл эгет нисл.',
                videoTitle: 'Видео презентация',
                videoDescription: 'Это видео объясняет ключевые концепции темы. Внимательно просмотрите его, чтобы понять основные идеи.',
                bulletTitle: 'Ключевые пункты',
                bullet1: 'Первый важный пункт для запоминания по этой теме',
                bullet2: 'Второй ключевой концепт, который основывается на первом пункте',
                bullet3: 'Третий существенный элемент, который завершает понимание',
                imageTitle: 'Визуальное представление',
                imageCaption: 'Это изображение иллюстрирует концепцию, описанную в этой главе. Внимательно изучите его, чтобы понять визуальные элементы.',
                textBulletTitle: 'Обзор концепции',
                textContent: 'Этот раздел предоставляет подробное объяснение концепции. Текст вводит основные идеи и предоставляет контекст для понимания ключевых пунктов, перечисленных справа.',
                textBullet1: 'Ключевой пункт, связанный с концепцией, объясненной в тексте',
                textBullet2: 'Дополнительная информация, которая поддерживает основную концепцию',
                textBullet3: 'Заключительный пункт, который завершает понимание темы',
                videoBulletTitle: 'Видео руководство с ключевыми пунктами',
                videoBullet1: 'Посмотрите видео, чтобы понять демонстрацию',
                videoBullet2: 'Следуйте шагам, показанным в видео',
                videoBullet3: 'Обращайтесь к этим пунктам во время просмотра видео',

                // Two-column image template content
                twoColumnImageTitle: 'Сравнение изображений',
                twoColumnImageCaption: 'Эти изображения иллюстрируют различные аспекты концепции. Сравните их, чтобы понять ключевые различия и сходства.',

                // Three-column text template content
                threeColumnTitle: 'Трехэтапный процесс',
                column1Text: 'Шаг 1: Начните с понимания основных принципов и основ концепции. Этот начальный этап имеет решающее значение для построения прочного понимания.',
                column2Text: 'Шаг 2: Применяйте принципы в практических сценариях и исследуйте, как они взаимодействуют с реальными ситуациями. Практика необходима для мастерства.',
                column3Text: 'Шаг 3: Оцените свое понимание и усовершенствуйте свой подход на основе обратной связи и результатов. Постоянное совершенствование ведет к экспертизе.',

                // Image gallery template content
                imageGalleryTitle: 'Галерея визуальных примеров',
                imageGalleryCaption: 'Эта коллекция изображений демонстрирует различные аспекты темы. Каждое изображение представляет собой различный пример или применение.',

                // Video with overlay template content
                videoOverlayTitle: 'Видео с ключевыми моментами',
                videoOverlayText: 'ВАЖНО: Обратите особое внимание на эту демонстрацию, так как она показывает критически важные техники.',

                // Title with background template content
                backgroundTitle: 'Обзор главы',
                backgroundSubtitle: 'Основные концепции и принципы',
                backgroundText: 'Эта глава представляет фундаментальные концепции, которые формируют основу предмета. Понимание этих принципов имеет решающее значение для освоения более продвинутых тем, которые следуют далее.'
            }
        },
        courseTemplateBank: {
            title: 'Создать курс с помощью ИИ',
            description: 'Выберите шаблон курса для создания нового курса с контентом, сгенерированным искусственным интеллектом',
            courseTemplatesTitle: 'Шаблоны курсов',
            chapterTemplatesTitle: (key, { count }) => `Включенные слайды (${count})`,
            slideCount: (key, { count }) => `${count} слайдов`,
            defaultCourseTitle: 'Новый курс',
            defaultCourseDescription: 'Курс, созданный с помощью ИИ',
            defaultSectionTitle: 'Раздел 1',
            cancelButton: 'Отмена',
            createButton: 'Создать курс',
            yourDescription: 'Описание вашего курса:',
            defaultTemplatesTab: 'Шаблоны по умолчанию',
            designedTemplatesTab: 'Дизайнерские шаблоны',
            loadingTemplates: 'Загрузка шаблонов...',
            noDesignedTemplates: 'В настоящее время нет доступных дизайнерских шаблонов.',
            estimatedDuration: (key, { duration }) => `${duration} мин`,
            noDescription: 'Описание недоступно',
            noPreviewAvailable: 'Предварительный просмотр недоступен',
            generationStartError: 'Произошла ошибка при запуске создания курса. Пожалуйста, попробуйте снова.',
            courseTypes: {
                business: 'Бизнес',
                technical: 'Технический',
                educational: 'Образовательный',
                onboarding: 'Адаптация сотрудников',
                compliance: 'Соответствие нормам',
                product: 'Продукт'
            },
            templates: {
                businessCourse: {
                    name: 'Бизнес-курс',
                    description: 'Комплексный шаблон бизнес-курса со слайдами, охватывающими ключевые бизнес-концепции, стратегии и кейс-стади'
                },
                technicalCourse: {
                    name: 'Технический курс',
                    description: 'Подробный шаблон технического курса со слайдами, охватывающими технические концепции, демонстрации и практические примеры'
                },
                educationalCourse: {
                    name: 'Образовательный курс',
                    description: 'Структурированный шаблон образовательного курса со слайдами, разработанными для эффективного обучения и сохранения знаний'
                },
                onboardingCourse: {
                    name: 'Курс адаптации сотрудников',
                    description: 'Шаблон курса адаптации со слайдами для ознакомления новых сотрудников с политиками, процедурами и культурой компании'
                },
                complianceCourse: {
                    name: 'Курс соответствия нормам',
                    description: 'Шаблон курса соответствия нормам со слайдами, охватывающими нормативные требования, лучшие практики и процедуры соответствия'
                },
                productCourse: {
                    name: 'Курс по продукту',
                    description: 'Шаблон курса обучения продукту со слайдами, демонстрирующими функции продукта, преимущества и примеры использования'
                }
            }
        }
    },
    AIGeneration: {
        titles: {
            WEEZBEE_COURSE: 'Создать курс с помощью ИИ',
            EXAM: 'Создать экзамен с помощью ИИ',
            SURVEY: 'Создать опрос с помощью ИИ',
            default: 'Создать контент с помощью ИИ',
        },
        buttonText: {
            WEEZBEE_COURSE: 'Создать курс с AI',
            EXAM: 'Создать вопросы с AI',
            SURVEY: 'Создать вопросы с AI',
            default: 'Создать с AI',
        }
    },
    videoPlayer: {
        pleaseEnterVideoUrl: 'Пожалуйста, введите URL видео',
    },
    imageBank: {
        title: 'Банк изображений компании',
        noImages: 'В банке изображений компании не найдено изображений.',
        clickToCopy: 'Нажмите, чтобы скопировать ссылку',
        urlCopied: 'Ссылка на изображение скопирована в буфер обмена!',
        copyFailed: 'Не удалось скопировать ссылку. Пожалуйста, попробуйте скопировать вручную.',
        fetchError: 'Не удалось загрузить изображения. Пожалуйста, попробуйте позже.',
        featureFlagDisabled: 'Функция банка изображений не активирована для вашей компании.'
    },
    course: {
        untitled: 'Курс без названия',
        notFound: 'Курс не найден. Пожалуйста, проверьте URL или обратитесь в службу поддержки.',
        fetchError: 'Не удалось загрузить курс. Пожалуйста, попробуйте позже.',
        loading: 'Загрузка курса...',
        error: 'Ошибка загрузки курса',
        error: {
            sessionDateRequired: 'Пожалуйста, установите дату и время занятия перед назначением организациям'
        }
    },
    assetBank: {
        title: 'Банк ресурсов компании',
        publicTitle: 'Публичный банк ресурсов',
        noImages: 'В банке ресурсов компании не найдено изображений.',
        noVideos: 'В банке ресурсов компании не найдено видео.',
        clickToCopy: 'Нажмите, чтобы скопировать ссылку',
        urlCopied: 'Ссылка скопирована в буфер обмена!',
        copyFailed: 'Не удалось скопировать ссылку. Пожалуйста, попробуйте скопировать вручную.',
        fetchImageError: 'Не удалось загрузить изображения. Пожалуйста, попробуйте позже.',
        fetchVideoError: 'Не удалось загрузить видео. Пожалуйста, попробуйте позже.',
        imagesTab: 'Изображения',
        videosTab: 'Видео',
        featureFlagDisabled: 'Функция банка ресурсов не активирована для вашей компании.',
        addToChapterTooltip: 'Добавить в главу',
        addToChapter: 'Добавить в главу',
        addAsBackgroundTooltip: 'Добавить как фон главы',
        addAsBackground: 'Добавить как фон',
        addedToChapter: (key, { type }) => `${type === 'image' ? 'Изображение' : 'Видео'} добавлено в главу!`,
        addedAsBackground: 'Изображение добавлено как фон главы!',
        addedAsBackgroundVideo: 'Видео добавлено как фон главы!',
        uploadImage: 'Загрузить изображение',
        uploadVideo: 'Загрузить видео',
        uploadSuccess: 'Файл успешно загружен',
        uploadError: 'Ошибка загрузки файла',
        invalidFileType: 'Недопустимый тип файла',
        fileTooLarge: (key, { maxSize }) => `Файл слишком большой. Максимальный размер ${maxSize}`
    },
    signDoc: {
        finishByDuration: {
            toggleLabel: 'Установить время на выполнение задачи',
            title: 'Время на выполнение',
            note: 'Количество дней, которые есть у пользователя для выполнения задачи с момента назначения'
        },
        assignmentWarning: {
            title: 'Предупреждение о назначении',
            editingWillBeLocked: 'Предупреждение: После назначения этого документа организационным единицам редактирование вопросов будет заблокировано для сохранения целостности обучения.',
            editingLocked: 'Обратите внимание: Редактирование вопросов не разрешено из-за предыдущих назначений организационным единицам.',
            continueAssignment: 'Продолжить назначение',
            cancel: 'Отмена'
        },
        organizationAssignmentWarning: {
            title: 'Не выбраны организационные единицы',
            message: 'Вы не назначили эту задачу ни одной организационной единице. Это означает, что пользователи не смогут увидеть или выполнить эту задачу.',
            description: 'Чтобы сделать эту задачу видимой для пользователей, необходимо назначить её хотя бы одной организационной единице.',
            goBack: 'Вернуться',
            continueWithoutAssignment: 'Продолжить без назначения'
        },
        editDisabled: {
            assignedToOrganizations: 'Редактирование отключено, поскольку этот документ был назначен организационным единицам. Это сохраняет целостность обучения и обеспечивает последовательную оценку.',
            editQuestionsDisabled: 'Редактирование вопросов отключено для документов, назначенных организационным единицам'
        },
        sequentialActiveVersionModal: {
            title: 'Заменить активную версию?',
            message: (key, {activeVersionName}) => `"${activeVersionName}" — текущая активная версия этого повторяющегося контента.`,
            subMessage: 'Только одна версия может быть активной одновременно. Активация этой версии переместит предыдущую в архив. Пользователи, назначенные на предыдущую версию, также будут назначены на новую версию, а предыдущая версия появится в их архиве.',
            declineButton: 'Отмена',
            agreeButton: 'Заменить и активировать'
        }
    },
    courseAttendance: {
        title: 'Посещаемость курсов',
        description: 'Отметьте посещаемость или отсутствие для пользователей, зарегистрированных на курсах',
        searchPlaceholder: 'Поиск по имени пользователя или курсу...',
        noData: 'Нет курсов, ожидающих отметки посещаемости',
        columns: {
            userName: 'Имя пользователя',
            phone: 'Телефон',
            idNumber: 'Номер удостоверения',
            courseName: 'Название курса',
            courseType: 'Тип курса',
            sessionDate: 'Дата сеанса',
            actions: 'Действия'
        },
        courseTypes: {
            frontal: 'Очный',
            online: 'Онлайн'
        },
        actions: {
            markAttended: 'Отметить посещение',
            markNoShow: 'Отметить отсутствие'
        },
        tooltips: {
            sessionNotToday: 'Посещаемость можно отметить только в день сеанса'
        },
        errors: {
            markAttendedFailed: 'Ошибка при отметке посещения. Пожалуйста, попробуйте снова.',
            markNoShowFailed: 'Ошибка при отметке отсутствия. Пожалуйста, попробуйте снова.'
        },
        filters: {
            allCourses: 'Все курсы'
        }
    },
    courseFields: {
        sessionStartDate: 'Дата и время начала',
        sessionDuration: 'Продолжительность урока (в минутах)',
        location: 'Местоположение (адрес/комната)',
        meetingLink: 'Ссылка на встречу (Zoom/Google Meet)',
        instructor: 'Имя инструктора',
        onlineSession: 'Онлайн-сеанс',
        invalidMeetingLink: 'Пожалуйста, введите действительную ссылку на встречу с признанной платформы (Zoom, Microsoft Teams, Google Meet, Webex, GoToMeeting, Jitsi, Whereby и т.д.)',
    },
    certifications: {
        category: 'Категория',
        categoryForceCompletion: 'Обязательное задание',
        categoryCertification: 'Сертификация',
        categoryKnowledgeCenter: 'База знаний',
        categoryChangeDisabled: {
            multipleVersions: 'Невозможно изменить категорию при наличии нескольких версий'
        },
        expiryDuration: {
            toggleLabel: 'Добавить срок действия сертификата',
            title: 'Срок действия сертификата',
            valueLabel: 'Продолжительность',
            unitLabel: 'Единица времени',
            units: {
                years: 'Годы',
                months: 'Месяцы',
                days: 'Дни'
            },
            note: 'Установите срок действия сертификата. Система рассчитает дату истечения срока с даты получения сертификата.'
        },
    },
    durationPicker: {
        label: 'Продолжительность для завершения',
        valueLabel: 'Количество',
        valuePlaceholder: 'Введите значение',
        unitPlaceholder: 'Выберите единицу',
        days: 'Дни',
        months: 'Месяцы',
        years: 'Годы',
        MINUTES: 'Минуты',
        DAYS: 'Дни',
        MONTHS: 'Месяцы',
        YEARS: 'Годы',
        errorInvalidValue: 'Пожалуйста, введите положительное число'
    },
    selectDurationModal: {
        titleOrg: 'Установить продолжительность для организационной единицы',
        titleUser: 'Установить продолжительность для пользователя',
        durationLabel: 'Время для выполнения задачи',
        explanation: 'Пользователи получат срок, рассчитанный от даты их назначения. Например, если вы установите 60 дней, пользователь, назначенный сегодня, получит 60 дней для выполнения задачи.'
    },
    userProgressReport: {
        exportToExcel: 'Экспорт в Excel',
        exporting: 'Экспорт...',
        exportCurrentFilters: 'Экспорт текущих фильтров'
    },
    learningManagement: {
        createEditNewSignDocModal: {
            approversSection: {
                title: 'Выберите утверждающих (необязательно)',
                description: 'Выберите конкретных пользователей, которые могут утверждать загрузки. Если не выбрано, все администраторы назначенных организационных единиц будут утверждающими.',
                userLabel: 'Выберите конкретных пользователей в качестве утверждающих',
                defaultInfo: 'Если конкретные пользователи не выбраны, только вы или администраторы компании смогут утверждать загрузки'
            },
            individualUsersSection: {
                title: 'Назначить отдельным пользователям',
                userLabel: 'Поиск пользователей для индивидуального назначения',
                searchLabel: 'Поиск пользователей',
                searchPlaceholder: 'Введите имя, телефон или email...',
                noUsersFound: 'Пользователи, соответствующие вашему запросу, не найдены',
            },
            // Organization search
            organizationsSection: {
                searchLabel: 'Поиск организации',
                searchPlaceholder: 'Введите название организации...',
            },
            // User pagination labels
            noUsers: 'Пользователи не найдены',
            selectedLabel: 'пользователей выбрано',
            noOrganizations: 'Организации не найдены',
            selectedOrgsLabel: 'организаций выбрано',
            userPaginationError: 'Ошибка загрузки пользователей',
            userPaginationErrorMessage: 'Не удалось загрузить список пользователей. Пожалуйста, попробуйте снова, используя стрелки навигации.',
            orgPaginationError: 'Ошибка загрузки организаций',
            orgPaginationErrorMessage: 'Не удалось загрузить список организаций. Пожалуйста, попробуйте снова, используя стрелки навигации.',
            uploadError: 'Ошибка загрузки файла',
            uploadErrorMessage: 'Загрузка не удалась. Пожалуйста, попробуйте снова.'
        }
    },
    addToHomeScreen: {
        title: 'Установить приложение',
        description: 'Установите WeezBee на ваше устройство для быстрого доступа и лучшего опыта.',
        install: 'Установить сейчас',
        dismiss: 'Понятно, спасибо!',
        neverAskAgain: 'Больше не показывать',
        benefits: {
            faster: 'Быстрый доступ',
            offline: 'Работает офлайн',
            homeScreen: 'Ярлык на главном экране'
        },
        iosInstructions: {
            title: 'Чтобы установить приложение на ваш iPhone:',
            step1Part1: 'Нажмите кнопку "Поделиться"',
            step1Part2: '- находится в адресной строке или меню',
            step2: 'Прокрутите вниз в открывшемся меню',
            step3: 'Нажмите "На экран «Домой»"',
            step4: 'Нажмите "Добавить" в верхнем углу для завершения'
        }
    },
    learningPath: {
        sequentialOnlyDisclaimer: 'Этот учебный маршрут определён как "повторяющийся" - можно добавлять только повторяющиеся задания',
        freePath: {
            checkboxLabel: 'Свободный маршрут — выполняйте задания в любом порядке',
            checkboxHelper: 'При включении назначенные пользователи могут приступить к любому заданию сразу и выполнять их в любом порядке. При отключении задания нужно выполнять последовательно.',
            adminBanner: 'Режим свободного маршрута включён. Назначенные пользователи могут выполнять задания в любом порядке.',
            confirmSwitchToOrderedTitle: 'Перейти к последовательному порядку заданий?',
            confirmSwitchToOrderedBody: 'Этот учебный маршрут сейчас задан как свободный и уже назначен пользователям. Переход к последовательному порядку означает, что назначенные пользователи будут обязаны выполнять задания в заданном порядке. Пользователи, уже выполнившие задания не по порядку, сохранят свой прогресс, но следующим доступным заданием будет первое незавершённое в последовательности — что может показаться неожиданным. Вы уверены?',
            confirmSwitchToOrderedConfirm: 'Перейти к последовательному',
            badge: 'Свободный путь',
        },
    },
};
